export default {
    "en": {
        "about_us": {
            "why_we_exist": {
                "title": "Why We Exist",
                "description": "Our purpose at Franchiseur is simple: make entrepreneurship accessible, innovative, and rewarding. We provide ambitious entrepreneurs the resources and flexibility they need to build businesses and make their mark.<br \/><br \/>\nWith each proven brand known for delivering top-tier experiences, we offer more than products and services; we create lasting relationships with our customers and franchise partners, ensuring each franchisee has the support needed to grow sustainably in today’s fast-changing market.",
                "business_was_founded": "Business was founded",
                "people_on_the_team": "People on the team",
                "locations": "Locations",
                "yearly_revenue": "Yearly Revenue"
            },
            "our_history": {
                "title": "Our History"
            },
            "who_is_franchiseur": {
                "title": "Who is the Franchiseur",
                "description": "For over 12 years, Jim Cam, the visionary known as the Franchiseur, has been transforming industries and creating lasting business models. With over 100 locations in Canada, Jim built a franchise network of trusted and successful brands grounded in trust, diversity, innovation, and entrepreneurial empowerment.<br \/><br \/>\nHis story is one of resilience, having taught himself through practical experience and an unyielding commitment to long-term growth and excellence, Jim’s leadership prioritizes franchisees’ success to thrive not only today but also for the challenges of tomorrow. With Franchiseur, Jim has established a lasting legacy that continues to shape the franchising world."
            },
            "our_values": {
                "title": "Our Values",
                "value_1": "Franchisee Empowerment & Success",
                "value_description_1": "We are committed to providing franchisees with the knowledge, tools, and freedom to thrive in today’s market. Their entrepreneurial success fuels our shared growth and excellence.",
                "value_2": "Flexibility & Growth",
                "value_description_2": "We embrace change and empower our franchisees to stay ahead of market trends and challenges in fast-evolving industries. Adaptability in our approach ensures both long-term viability and sustainable expansion.",
                "value_3": "Collaboration, Teamwork & Integrity",
                "value_description_3": "We cultivate a transparent, collaborative culture where franchisees, employees, and teams unite for shared success."
            }
        },
        "account": {
            "home": "Home",
            "profile": "Profile",
            "qr_code": "Code",
            "settings": "Settings",
            "change_password": "Change Password",
            "change_password_description": "A secure password helps protect your account.",
            "qr_header": "Earn & save with your code.",
            "qr_description": "Show this QR code to our staff to access your account.",
            "account_information": "Account Information",
            "update_account_description": "Update your account's profile information",
            "delete_account": "Delete Account",
            "delete_account_disclaimer": "Once your account is deleted, all of its data will be permanently deleted. Before deleting your account, please save a copy any data or information that you wish to retain.",
            "delete_account_confirmation": "Are you sure you want to delete your account?",
            "delete_account_instructions": "Once your account is deleted, all of its data will be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.",
            "account": "Account",
            "account_settings": "Account Settings",
            "my_account": "My Account",
            "my_profile": "My Profile",
            "my_profile_description": "This information will help identify your orders.",
            "social_login": "Continue with {social_media}",
            "or": "or",
            "name": "Name",
            "first_name": "First Name",
            "last_name": "Last Name",
            "email": "Email Address",
            "email_or_phone": "Email Address or Phone Number",
            "password": "Password",
            "confirm_password": "Confirm Password",
            "forgot_password": "Forgot password",
            "current_password": "Current Password",
            "new_password": "New Password",
            "phone_number": "Phone Number",
            "remember_me": "Remember me",
            "new_user": "Don't have an account?",
            "existing_user": "Already have an account?",
            "welcome": "Welcome, {name}",
            "almost_there": "You're almost there!",
            "reset_password": "Reset Password",
            "verify": "Verify Phone Number",
            "otp": "Enter the 6-digit code sent to you.",
            "newsletter": "I want to join the VIP list for exclusive access to special promotions and discounts.",
            "terms_and_conditions": {
                "agree": "By checking this box, I confirm that I have read and agree to the",
                "and": "and"
            },
            "success_messsage": {
                "account": "Your profile has been successfully updated",
                "password": "Your password has been successfully updated",
                "payment": {
                    "create": "Your payment method has been successfully saved",
                    "update": "Your payment method has been successfully updated",
                    "delete": "Your payment method has been successfully deleted"
                },
                "address": {
                    "create": "Your address has been successfully saved",
                    "update": "Your address has been successfully updated",
                    "delete": "Your address has been successfully deleted"
                }
            }
        },
        "actions": {
            "accept": "Accept",
            "add_exception": "Add Exception",
            "add_time_slot": "Add Time Slot",
            "add": "Add",
            "agree": "Agree",
            "apply": "Apply",
            "back": "Back",
            "begin": "Begin",
            "by": "by",
            "cancel": "Cancel",
            "change": "Change",
            "checkout": "Checkout",
            "close": "Close",
            "collapse": "Collapse",
            "confirm": "Confirm",
            "confirmation": {
                "delete": "Are you sure you want to delete? This cannot be undone.",
                "submit": "Are you sure you want to submit?",
                "update": "Are you sure you want to update?"
            },
            "create": "Create",
            "decline": "Decline",
            "delete": "Delete",
            "delete_account": "Delete Account",
            "disable": "Disable",
            "done": "Done",
            "download": "Download",
            "edit": "Edit",
            "enable": "Enable",
            "end": "End",
            "exit": "Exit",
            "expand": "Expand",
            "filter": "Filter",
            "find": "Find",
            "follow": "Follow",
            "go": "Go",
            "help": "Help",
            "hide_all": "Hide All",
            "hide": "Hide",
            "home": "Home",
            "less": "Less",
            "log_in": "Log In",
            "log_out": "Log Out",
            "manage": "Manage",
            "maximize": "Maximize",
            "minimize": "Minimize",
            "more": "More",
            "new": "New",
            "next": "Next",
            "no_results": "No results",
            "no": "No",
            "off": "Off",
            "okay": "Okay",
            "on": "On",
            "open": "Open",
            "other": "Other",
            "pay": "Pay",
            "pay_now": "Pay Now",
            "previous": "Previous",
            "print": "Print",
            "publish": "Publish",
            "recommend": "Recommend",
            "redo": "Redo",
            "refund": "Refund",
            "register": "Register",
            "remove": "Remove",
            "reserve": "Reserve",
            "reserve_a_table": "Reserve a Table",
            "return": "Return",
            "save": "Save",
            "search": "Search",
            "select": "Select",
            "send": "Send",
            "show_all": "Show All",
            "show": "Show",
            "sign_up": "Sign Up",
            "social_login": "Continue with {provider}",
            "start": "Start",
            "stop": "Stop",
            "submit_a_ticket": "Submit a ticket",
            "submit": "Submit",
            "subscribe": "Subscribe",
            "undo": "Undo",
            "unsubscribe": "Unsubscribe",
            "update": "Update",
            "upload": "Upload",
            "view_all": "View All",
            "view_cart": "View Cart",
            "view_menu": "View Menu",
            "view_more": "View More",
            "view_order": "View Order",
            "view": "View",
            "yes": "Yes"
        },
        "address": {
            "address_line_1": "Address",
            "address_line_2": "Apartment, unit, etc.",
            "city": "City",
            "province": "Province",
            "state": "State",
            "postal_code": "Postal Code",
            "zip_code": "Zip Code",
            "country": "Country",
            "latitude": "Latitude",
            "longitude": "Longitude"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "brand": {
            "bapbol": {
                "hero_title": "BAP BOL | Korean bowls & franchising",
                "hero_headline": "Korean flavours in a bowl.",
                "hero_description": "Discover a modern, bowl-first concept that brings bold flavours and everyday convenience together.",
                "hero_alt": "A sauced BAP BOL bowl with rice, carrots, cabbage and noodles in a white ceramic bowl on a cream tabletop",
                "about": {
                    "section_label": "The brand",
                    "tagline": "Modern Korean, made for everyday life.",
                    "description_1": "Founded in Montreal in 2026, BAP BOL is a Korean fast-casual concept built around rice bowls, bold flavours and an approachable experience.",
                    "description_2": "Complete meals, clear flavours and colourful ingredients: the bowl is at the heart of our menu. Made to order and easy to enjoy, it fits naturally into lunch, dinner and takeaway routines."
                },
                "values": {
                    "fresh": {
                        "title": "Fresh",
                        "description": "Prepared with care, with colourful ingredients at the centre of every bowl."
                    },
                    "fast": {
                        "title": "Fast",
                        "description": "Made for modern routines, from a quick lunch to dinner on the go."
                    },
                    "flavourful": {
                        "title": "Flavourful",
                        "description": "Bold Korean flavours that make every meal something to look forward to."
                    },
                    "approachable": {
                        "title": "Approachable",
                        "description": "An easy way to discover Korean food, with familiar formats and plenty of choice."
                    }
                },
                "menu": {
                    "tagline": "Korean food, built around the bowl",
                    "title": "Signature Korean bowls.",
                    "made_to_order": "Made to order",
                    "signature_alt": "Four BAP BOL bowls with assorted toppings, rice and vegetables on a warm wooden table",
                    "categories": {
                        "bulgogi": "Bulgogi Bowl",
                        "spicy_pork": "Spicy Pork Bowl",
                        "fried_chicken": "Korean Fried Chicken Bowl",
                        "teriyaki_chicken": "Soy Chicken Bowl",
                        "veggie": "Veggie Bowl"
                    },
                    "gallery": {
                        "katsu_kick": {
                            "title": "Katsu Kick",
                            "description": "Crispy breaded chicken katsu with tonkatsu sauce.",
                            "alt": "Katsu Kick with sliced breaded chicken, rice and vegetables in a white ceramic bowl on a wooden table"
                        },
                        "mandu_crunch": {
                            "title": "Mandu Crunch",
                            "description": "Crispy, deep-fried vegetable dumplings.",
                            "alt": "Mandu Crunch with sauced dumplings, rice, noodles and vegetables in a white ceramic bowl beside linen and chopsticks"
                        },
                        "seoul_crunch": {
                            "title": "Seoul Crunch",
                            "description": "Korean fried chicken with a sweet, spicy glaze.",
                            "alt": "Seoul Crunch with glazed pieces, rice, noodles and vegetables in a white ceramic bowl with a glass in the background"
                        },
                        "smoky_pork": {
                            "title": "Smoky Pork",
                            "description": "Soy-marinated bulgogi pork with a gently sweet, savoury flavour.",
                            "alt": "Smoky Pork with sliced pork, rice, noodles and vegetables in a white ceramic bowl beside chopsticks on a ceramic rest"
                        },
                        "soy_drip": {
                            "title": "Soy Drip",
                            "description": "Soy-marinated bulgogi chicken with a sweet, savoury finish.",
                            "alt": "Soy Drip with sliced chicken, rice, noodles and vegetables in a white ceramic bowl beside cream linen and a water glass"
                        },
                        "bulgogi_beef": {
                            "title": "Beef Boss",
                            "description": "Korean BBQ beef, marinated and grilled for savoury sweetness.",
                            "alt": "Beef Boss with sliced beef, rice, noodles and vegetables in a white ceramic bowl beside a charcoal napkin"
                        },
                        "heat_drop": {
                            "title": "Heat Drop",
                            "description": "Chicken stir-fried in sweet and spicy gochujang sauce.",
                            "alt": "Heat Drop with sauced pieces, sesame, rice and vegetables in a white ceramic bowl beside a rust-coloured napkin"
                        },
                        "red_fury": {
                            "title": "Red Fury",
                            "description": "Pork stir-fried with sweet and spicy gochujang.",
                            "alt": "Red Fury with sauced slices, rice, noodles and vegetables in a white ceramic bowl beside ivory linen and metal chopsticks"
                        },
                        "noodle_flex": {
                            "title": "Noodle Flex",
                            "description": "Japchae: sweet potato noodles stir-fried with vegetables and Korean seasoning.",
                            "alt": "Noodle Flex with noodles, rice, cabbage and carrots in a white ceramic bowl beside striped linen"
                        }
                    },
                    "description": "Satisfying, colourful and made to order. Our signature bowls bring Korean flavours together in a complete meal.",
                    "base_title": "In every bowl",
                    "base_description": "Rice, napa cabbage, glass noodles and pickled carrots accompany every bowl."
                },
                "support_service": {
                    "title": "Franchise support, every step of the way",
                    "subtitle": "From planning your location to supporting your team, build your BAP BOL franchise with guidance throughout the journey.",
                    "image_alt": "BAP BOL bowls and Korean snacks",
                    "steps": {
                        "site_selection": {
                            "title": "Site selection",
                            "description": "Guidance on location evaluation and lease planning."
                        },
                        "financial_support": {
                            "title": "Financial planning",
                            "description": "Support with investment planning and preparing your business plan."
                        },
                        "training_program": {
                            "title": "Training",
                            "description": "Prepare your team for the menu, service and daily operations."
                        },
                        "operational_support": {
                            "title": "Operational support",
                            "description": "Guidance on consistent preparation, service and restaurant routines."
                        },
                        "marketing_community": {
                            "title": "Marketing and community",
                            "description": "Plan your launch and connect with your local community."
                        }
                    }
                },
                "cta": {
                    "title": "Bring BAP BOL to your community.",
                    "description": "Explore a Korean fast-casual franchise built around signature bowls, bold flavours and an approachable experience. Start a conversation with our team.",
                    "image_alt": "A sliced-chicken bowl with sesame, rice and vegetables on a dark tabletop"
                }
            },
            "title": "Become a franchise owner of",
            "subtitle": "Create and develop your legacy with our proven and verified brands. Start your entrepreneurial adventure with us.",
            "cta": "This a sneak peek! We're now accepting applications!",
            "franchise_process": {
                "title": "Turnkey Franchising Service",
                "subtitle": "We guide you through every step of the process",
                "steps": {
                    "lets_talk": {
                        "title": "Let's Talk",
                        "description": "Franchise Presentation"
                    },
                    "validation": {
                        "title": "Franchisee Validation",
                        "description": "Deposit & Location Selection"
                    },
                    "rental_research": {
                        "title": "Rental Space Research",
                        "description": "Evaluation & Selection"
                    },
                    "costs_estimation": {
                        "title": "Costs Estimation",
                        "description": "Business Plan & Bank Loan"
                    },
                    "incorporation": {
                        "title": "Incorporation",
                        "description": "Renovation, Training & Launch"
                    }
                },
                "image_alt": "Next Step"
            },
            "franchise_investment": {
                "title": "Franchising Fees",
                "acquisition_cost": {
                    "title": "Franchise Acquisition Cost",
                    "total_investment": "Total Investment: ${min} - ${max}"
                },
                "requirements": {
                    "title": "Requirements",
                    "down_payment": "Minimum ${amount} for down payment",
                    "credit_score": "Good credit score"
                },
                "cta_button": "Request Franchise Information",
                "fees": {
                    "franchising": "One time franchising fee",
                    "royalties": "Royalties",
                    "marketing": "Marketing fee",
                    "term": "Term of franchise",
                    "years": "years"
                }
            },
            "onigirishop": {
                "hero_title": "Onigiri Shop - Japanese Rice Ball Franchise",
                "hero_alt": "Onigiri Shop",
                "locations": {
                    "title": "Our Franchises",
                    "subtitle_template": "{count} stores and growing across Québec",
                    "cta_title": "Join Our Network",
                    "cta_description": "Become part of our growing family of successful franchise partners.",
                    "cta_button": "Start Your Journey"
                },
                "delivery_partners": {
                    "title": "Online Ordering & Delivery",
                    "subtitle": "Onigiri Shop partners with all major delivery services to provide convenient ordering options",
                    "footer_title": "Multi-Platform Strategy",
                    "footer_description": "We work closely with all major delivery platform partners to ensure healthy revenue streams and increase brand exposure across all channels, providing customers with convenient ordering options."
                },
                "about": {
                    "tagline": "Tradition meets innovation for a world-class dining experience",
                    "description_1": "At <b>Onigiri Shop<\/b>, our mission is to introduce the beloved Japanese onigiri to the world, adding a local twist with fresh, innovative ingredients. We aim to offer an accessible, affordable, and globally recognized dining experience, combining tradition with creativity.",
                    "description_2": "Our onigiri offers a unique fusion of flavors that appeals to diverse tastes while staying true to its Japanese roots.",
                    "image_alt": "Onigiri preparation"
                },
                "core_values": {
                    "title": "Five Core Pillars of Success for Franchisees",
                    "subtitle": "We are guided by five core values",
                    "values": {
                        "quality": {
                            "title": "Quality",
                            "description": "We are committed to using the freshest, highest-quality ingredients to create the best onigiri experience."
                        },
                        "innovation": {
                            "title": "Innovation",
                            "description": "We constantly experiment with new flavors and combinations, bringing new life to a traditional dish."
                        },
                        "collaboration": {
                            "title": "Collaboration",
                            "description": "We work closely with our franchisees, suppliers, and local communities to build a strong network that supports mutual growth and success."
                        },
                        "efficiency": {
                            "title": "Efficiency",
                            "description": "We streamline our operations to ensure that our restaurants are both cost-effective and provide a quick, high-quality service."
                        },
                        "transparency": {
                            "title": "Transparency",
                            "description": "We maintain clear and open communication with our franchisees, ensuring that all business processes are straightforward and honest."
                        }
                    },
                    "images": {
                        "quality_alt": "Quality ingredients",
                        "collaboration_alt": "Team collaboration",
                        "innovation_alt": "Innovation in kitchen",
                        "efficiency_alt": "Efficient operations"
                    }
                },
                "menu": {
                    "tagline": "Our most popular onigiri creations",
                    "title": "Our Top Sellers",
                    "items": {
                        "spicy_tuna": {
                            "title": "Spicy Tuna (Raw)",
                            "description": "Raw tuna, spicy mayo, togarishi",
                            "alt": "Spicy Tuna Raw"
                        },
                        "fresh_salmon": {
                            "title": "Fresh Salmon (Raw)",
                            "description": "fresh raw salmon, spicy mayo"
                        },
                        "fuji_mountain": {
                            "title": "Fuji Mountain",
                            "description": "Fresh salmon, kanikama shrimp, avocado, kelp, grilled cheese. egg yolks, furkake, tempura",
                            "alt": "Fuji Mountain"
                        },
                        "shrimp_kanikama": {
                            "title": "Shrimp-Kanikama",
                            "description": "cooked shrimp, goberge, kewpie mayo, poke sauce",
                            "alt": "Shrimp-Kanikama"
                        },
                        "k_pop": {
                            "title": "K-Pop",
                            "description": "Korean Fried Chicken, kimchi, Grilled cheese, furikake",
                            "alt": "K-Pop & Salmon Deluxe"
                        },
                        "salmon_deluxe": {
                            "title": "Salmon Deluxe",
                            "description": "Spicy fresh salmon, cooked salmon, ikura, furikake"
                        }
                    },
                    "cta_button": "View Full Menu"
                },
                "cta": {
                    "title": "Ready to Start Your Onigiri Shop Franchise?",
                    "description": "Join us in bringing authentic Japanese comfort food with innovative flavors to communities worldwide"
                }
            },
            "sushisama": {
                "hero_title": "Sushi Sama - Modern Japanese Sushi Franchise",
                "hero_description": "A modernized Japanese tradition. Experience authentic sushi prepared with finesse and diligence, where each roll has unique ingredients coming together in harmony.",
                "hero_alt": "Sushi Sama",
                "locations": {
                    "title": "Our Growing Network",
                    "subtitle_template": "Montreal based franchise brand, {count} stores across Québec and Ottawa",
                    "cta_title": "Join Our Successful Network",
                    "cta_description": "Be part of Québec's most established sushi franchise with proven success across diverse markets and demographics.",
                    "cta_button": "Start Your Sushi Sama Journey"
                },
                "delivery_partners": {
                    "title": "Online Ordering & Delivery",
                    "subtitle": "Sushi Sama partners with all major delivery services to provide convenient ordering options",
                    "footer_title": "Multi-Platform Strategy",
                    "footer_description": "We work closely with all major delivery platform partners to ensure healthy revenue streams and increase brand exposure across all channels, providing customers with convenient ordering options."
                },
                "about": {
                    "tagline": "Tradition meets innovation for a world-class dining experience",
                    "description_1": "At <b>Sushi Sama<\/b>, sushi is prepared with finesse and diligence. Each roll has unique ingredients coming together in harmony. The original names of each item reflect its contents and they have been carefully created by experienced Sushi Sama chefs.",
                    "description_2": "Whether it's to eat healthy or for a special event, you will be satisfied with your experience!",
                    "image_alt": "Sushi preparation by chef"
                },
                "menu": {
                    "title": "Our Diverse Menu",
                    "subtitle": "From traditional sushi to modern specialties, we cater to every type of lifestyle and dietary preference",
                    "categories": {
                        "appetizers": {
                            "title": "Appetizers",
                            "description": "Perfect starters",
                            "alt": "Appetizers"
                        },
                        "chef_specialty": {
                            "title": "Chef's Specialty",
                            "description": "Creative signature rolls with unique ingredients",
                            "alt": "Chef's Specialty"
                        },
                        "nigiri_sashimi": {
                            "title": "Nigiri & Sashimi",
                            "description": "Fresh premium fish served traditionally",
                            "alt": "Nigiri & Sashimi"
                        },
                        "poke_bowls": {
                            "title": "Poké Bowls",
                            "description": "Hawaiian-style fresh bowls",
                            "alt": "Poke Bowls"
                        },
                        "hosomaki": {
                            "title": "Hosomaki",
                            "description": "Traditional thin rolls",
                            "alt": "Hosomaki Rolls"
                        },
                        "bento": {
                            "title": "Bento Boxes",
                            "description": "Complete meals with rice, salad and main course",
                            "alt": "Bento Boxes"
                        },
                        "platters": {
                            "title": "Platters",
                            "description": "Value combination plates",
                            "alt": "Combo Plates"
                        },
                        "sushi_pizza": {
                            "title": "Sushi Pizza",
                            "description": "Fusion innovation",
                            "alt": "Sushi Pizza"
                        },
                        "tartare": {
                            "title": "Tartare",
                            "description": "Fresh raw fish delicacy",
                            "alt": "Tartare"
                        }
                    },
                    "closing_text_1": "Whether our customers are on lunch break, dinner, or need a quick bite on the go, everyone will find something for their needs and occasion.",
                    "closing_text_2": "The diversity of our menu allows us to cater to every type of lifestyle and dietary preference."
                },
                "franchise_investment": {
                    "why_choose_title": "Why Choose Sushi Sama?",
                    "benefits": {
                        "successful_locations": {
                            "title": "{count} Established locations",
                            "description": "Proven track record across Québec & Ottawa"
                        },
                        "multi_platform": {
                            "title": "Multi-Platform Delivery",
                            "description": "Available on all major delivery platforms"
                        },
                        "flexible_locations": {
                            "title": "Flexible Locations",
                            "description": "Low rent and flexible space requirements"
                        },
                        "delivery_support": {
                            "title": "Delivery Team Support",
                            "description": "Full support for delivery operations"
                        }
                    }
                },
                "cta": {
                    "title": "Ready to Start Your Sushi Sama Franchise?",
                    "description": "Join Québec's most established sushi franchise with {count} successful locations and a modernized approach to Japanese tradition.",
                    "image_alt": "Sushi Sama"
                },
                "support_service": {
                    "title": "Our Support & Service",
                    "subtitle": "Comprehensive franchise support from start to success",
                    "image_alt": "Sushi Sama Support",
                    "steps": {
                        "site_selection": {
                            "title": "Site Selection",
                            "description": "Our experienced real estate\/development team will assist you in selecting your site and negotiating your lease."
                        },
                        "financial_support": {
                            "title": "Financial Support",
                            "description": "We work with you to ensure your financial institution has the information they require. We have a national franchise program with multiple major credit unions."
                        },
                        "training_program": {
                            "title": "Training Program",
                            "description": "We provide franchisees theoretical and practical training. We support the restaurant with a team of trainers who are on site to help you and your staff."
                        },
                        "operational_support": {
                            "title": "Operational Support",
                            "description": "Our dedicated and experienced operation team works with the franchisee to ensure respect of the Sushi Sama processes and high standards."
                        },
                        "marketing_community": {
                            "title": "Highly Engaged Community",
                            "description": "Sushi Sama is supported by a marketing team that provides local marketing programs tailored to the communities in which they are located."
                        }
                    }
                }
            },
            "lepokestation": {
                "hero_title": "Le Poké Station - Hawaiian Poké Bowl Franchise",
                "hero_alt": "Le Poké Station",
                "hero_description": "Experience authentic Hawaiian poké bowls prepared with finesse and diligence. Each bowl features unique, harmonious ingredients crafted by experienced chefs.",
                "about": {
                    "tagline": "ALOHA! Experience the taste of Hawaii",
                    "description": "At <b>Le Poké Station<\/b>, poké bowls are prepared with finesse and diligence. Each item on the menu has unique, harmonious ingredients that have been carefully created by experienced chefs. Whether it's to eat healthy or for a special event, you will be satisfied with your experience!",
                    "image_alt": "Poke bowl preparation"
                },
                "franchise_investment": {
                    "why_choose_title": "Why Choose Le Poké Station?",
                    "benefits": {
                        "successful_locations": {
                            "title": "{count} Established locations",
                            "description": "Proven track record across Québec & Ottawa"
                        },
                        "multi_platform": {
                            "title": "Multi-Platform Delivery",
                            "description": "Available on all major delivery platforms"
                        },
                        "flexible_locations": {
                            "title": "Flexible Locations",
                            "description": "Low rent and flexible space requirements"
                        },
                        "delivery_support": {
                            "title": "Delivery Team Support",
                            "description": "Full support for delivery operations"
                        }
                    }
                },
                "delivery_partners": {
                    "title": "Order Online & Delivery",
                    "subtitle": "Available on all major delivery platforms for convenient ordering",
                    "footer_title": "Comprehensive Delivery Network",
                    "footer_description": "Le Poké Station works with all major delivery platforms to provide maximum convenience and reach for our customers.",
                    "footer_extra_text": "Plus dedicated delivery driver team ensuring quality service!"
                },
                "locations": {
                    "title": "Our Locations",
                    "subtitle": "{count} stores across Québec & Ottawa",
                    "cta_title": "Join Our Growing Network",
                    "cta_description": "Be part of Québec's largest poké franchise network with proven success across multiple markets.",
                    "cta_button": "Start Your Franchise Journey"
                },
                "menu": {
                    "title": "Our Classic Bowls",
                    "subtitle": "Fresh, delicious, and customizable poké bowls with premium ingredients",
                    "items": {
                        "sama": {
                            "title": "Sama",
                            "description": "Spicy Salmon & Tuna, Marinated Salmon & Tuna",
                            "alt": "Sama bowl"
                        },
                        "katsu_chicken": {
                            "title": "Katsu Chicken",
                            "description": "Crispy chicken katsu with fresh veggies",
                            "alt": "Katsu chicken bowl"
                        },
                        "veggie": {
                            "title": "Veggie",
                            "description": "Sweet potato, inari, and edamame bowl",
                            "alt": "Veggie bowl"
                        },
                        "tuna": {
                            "title": "Tuna",
                            "description": "Spicy Tuna & Marinated Tuna",
                            "alt": "Tuna bowl"
                        }
                    }
                },
                "cta": {
                    "title": "Ready to Start Your Le Poké Station Franchise?",
                    "description": "Join Québec's largest poké franchise network and bring ALOHA to your community with fresh, healthy Hawaiian bowls!",
                    "image_alt": "Le Poké Station"
                },
                "support_service": {
                    "title": "Our Support & Service",
                    "subtitle": "Comprehensive support every step of the way",
                    "image_alt": "Le Poke Station Support",
                    "steps": {
                        "site_selection": {
                            "title": "Site Selection",
                            "description": "Our experienced real estate team will assist you in selecting your site and negotiating your lease."
                        },
                        "financial_support": {
                            "title": "Financial Support",
                            "description": "We help with financial institution requirements and loan applications through our credit union partnerships."
                        },
                        "training_program": {
                            "title": "Training Program",
                            "description": "Comprehensive theoretical and practical training with on-site support for you and your staff."
                        },
                        "operational_support": {
                            "title": "Operational Support",
                            "description": "Dedicated operation team ensures respect of processes and high standards with detailed manuals."
                        },
                        "marketing_community": {
                            "title": "Marketing Community",
                            "description": "Local marketing programs with in-house graphic department and engaged online community support."
                        }
                    }
                }
            },
            "kalemart24": {
                "title": "KaleMart24 - Where Wellness Meets Convenience",
                "tagline": "Where Wellness Meets Convenience",
                "hero": {
                    "title": "Join the fastest growing convenience store trend in the world.",
                    "description": "KaleMart24 is expanding across North America and is seeking franchise partners who wish to be part of this exciting and exclusive opportunity to join the one of the fastest growing convenience store trend in the world.",
                    "alt": "KaleMart24 Franchise Opportunity"
                },
                "about": {
                    "title": "An incomparable offering.",
                    "description": "KaleMart24 is breaking through the traditional convenience store mold which has been associated with junk food by offering healthier choices that cater to a mobile, savvy and younger consumer. From self-serve coffee counters to tasty ready-to-eat meals, KaleMart24 is a destination of its own. Making shopping for organic and healthy foods incredibly fun, with the homey feel of a market, yet the modern elegance of an upscale convenience store.",
                    "features": "Curating specialty brands and products, KaleMart24 includes all the usual sections of a convenience store, along with a coffee self-serve counter, a hot and cold grab-and-go meals section, a small personal care section, and a small organic pet section."
                },
                "why_franchise": {
                    "title": "Why",
                    "subtitle": "10 good reasons to get on the trend today:",
                    "reasons": {
                        "turn_key": "Turn-key solution",
                        "recession_resistant": "Recession resistant model",
                        "affordable_investment": "Affordable investment",
                        "full_service_design": "Full-service design team",
                        "real_estate_support": "Real estate and construction support",
                        "branding_marketing": "Top notch branding and marketing",
                        "supply_chain": "Strong supply chain and distribution",
                        "training": "On-going training",
                        "easy_to_operate": "Easy to operate",
                        "multi_unit": "Multi-unit opportunity"
                    }
                },
                "location_standards": {
                    "title": "Location Standards",
                    "size": {
                        "title": "Location Size",
                        "minimum": "Minimum of 750 sq. ft.",
                        "maximum": "Maximum of 2,000 sq. ft."
                    },
                    "locations": {
                        "title": "Locations",
                        "description": "Close-to-home or on the way to work locations are paramount to take advantage of the important food on-the-go category."
                    },
                    "preferred": {
                        "title": "Preferred Developments",
                        "types": "Metro stations; Universities; Downtown urban cores; Malls; Airports"
                    }
                },
                "process": {
                    "title": "Easy 5-Step Process",
                    "steps": {
                        "submit_request": {
                            "name": "Submit Request",
                            "description": "Submit your franchise request online."
                        },
                        "follow_up": {
                            "name": "Application Follow-Up",
                            "description": "Our franchise development team will reach out to you and send you a formal application to complete."
                        },
                        "agreement": {
                            "name": "Sign Agreement",
                            "description": "If your application is accepted, we provide you with the FDD, then we sign the franchise agreement and you become a KaleMart24 franchise partner"
                        },
                        "secure_build": {
                            "name": "Secure Location & Build",
                            "description": "We help you secure a location and start construction"
                        },
                        "train_open": {
                            "name": "Train & Open",
                            "description": "You complete the 2-weeks training and open your own KaleMart24!"
                        }
                    }
                },
                "locations": {
                    "title": "Find a KaleMart24 Near You",
                    "description": "We're growing fast across Canada and the USA! Don't see a KaleMart24 near you yet? Stay tuned—one might be popping up in your neighborhood sooner than you think!"
                },
                "investment": {
                    "title": "Franchise Requirements",
                    "description": "KaleMart24 is expanding across North America and is seeking franchise partners who wish to be part of this exciting and exclusive opportunity to join the one of the fastest growing convenience store trend in the world."
                },
                "cta": {
                    "title": "Ready to Start Your KaleMart24 Franchise?",
                    "description": "Join the wellness revolution in convenience retail. Be part of the fastest growing healthy convenience store trend.",
                    "image_alt": "KaleMart24"
                }
            },
            "ganadara": {
                "hero_title": "Ganadara - Korean Fusion Cuisine",
                "hero_description": "Ganadara serves a fusion of Korean food, expanding beyond in-restaurant dining to include take-out and delivery-only locations. The new concept is that the best meals are enjoyed in the comfort of your own home.",
                "hero_alt": "Ganadara",
                "locations": {
                    "title": "Our Franchises",
                    "subtitle_template": "{count} stores and growing across Québec",
                    "cta_title": "Join Our Network",
                    "cta_description": "Become part of our growing family of successful franchise partners.",
                    "cta_button": "Start Your Journey"
                },
                "delivery_partners": {
                    "title": "Online Ordering & Delivery",
                    "subtitle": "Ganadara partners with all major delivery services to provide convenient ordering options",
                    "footer_title": "Multi-Platform Strategy",
                    "footer_description": "With the increasing popularity of the delivery service, we are working very closely with all the major delivery platforms partner to ensure healthy revenue stream and to increase brand exposure."
                },
                "about": {
                    "tagline": "Modernized Korean tradition",
                    "description_1": "At <b>Ganadara<\/b>, we serve a fusion of Korean food, and the restaurant is expanding beyond the in-restaurant experience to add more take-out and delivery-only locations, the new concept is that the best meals are usually enjoyed in the comfort of your own home.",
                    "description_2": "Whether our customers are on lunch break, to have dinner, or need a quick bite on the go, everyone will find something for their needs and occassion. The diversity of our menu allows us to cater to every type of lifestyle and dietary preference.",
                    "image_alt": "About Ganadara"
                },
                "menu": {
                    "title": "Our Menu",
                    "subtitle": "From traditional Korean dishes to modern specialties, we cater to every type of lifestyle and dietary preference",
                    "highlights": {
                        "supreme_poutine": {
                            "title": "Suprême Poutine Tteokbokki",
                            "description": "Poutine Tteokbokki with mussels, beef and chicken"
                        },
                        "grilled_squid": {
                            "title": "Grilled Squid",
                            "description": "Char-grilled squid, perfect for sharing"
                        },
                        "soondubu": {
                            "title": "Soondubu",
                            "description": "Hot and hearty Korean stew"
                        },
                        "tteokkochi": {
                            "title": "Tteokkochi",
                            "description": "Chewy rice cakes glazed in sweet and spicy sauce"
                        },
                        "dolsot": {
                            "title": "Dolsot Bibimbap",
                            "description": "Bibimbap served in a hot stone bowl"
                        },
                        "dak_balls": {
                            "title": "Dak Balls",
                            "description": "Ganadara style fried chicken"
                        },
                        "mandu": {
                            "title": "Mandu",
                            "description": "Korean style dumpling"
                        }
                    }
                },
                "support_service": {
                    "title": "Our Support & Service",
                    "subtitle": "Comprehensive franchise support from start to success",
                    "image_alt": "Ganadara Support",
                    "steps": {
                        "site_selection": {
                            "title": "Site Selection",
                            "description": "Our experienced real estate\/development team will assist you in selecting your site and negotiating your lease."
                        },
                        "financial_support": {
                            "title": "Financial Support",
                            "description": "We will work with you to ensure your financial institution has the information they require to complete your loan application. Ganadara has a national franchise program with multiple major credit unions."
                        },
                        "training_program": {
                            "title": "Training Program",
                            "description": "We provide franchisees theoretical and practical training. We support the restaurant with a team of trainers who are on site to help you and your staff."
                        },
                        "operational_support": {
                            "title": "Operational Support",
                            "description": "Our dedicated and experienced operation team works with the franchisee to ensure respect of the Ganadara processes and high standards. Manuals covering all of the operating and management processes will be made available for your reference."
                        },
                        "marketing_community": {
                            "title": "Highly Engaged Community",
                            "description": "Ganadara is supported by a marketing team that provides local marketing programs tailored to the communities in which they are located. With an in-house graphic department and audiovisual specialists working full time, Ganadara's sunny ways reach far and wide. Moreover, the highly engaged online community shows just how close the Ganadara brand is to customers' hearts."
                        }
                    }
                },
                "cta": {
                    "title": "Ready to Start Your Ganadara Franchise?",
                    "description": "Join us in bringing authentic Korean fusion food to communities worldwide.",
                    "image_alt": "Ganadara Franchise"
                }
            },
            "turnberry": {
                "title": "TurnBerry Acai - Premium Acai Bowls",
                "tagline": "Home of the Berry Best Acai",
                "hero": {
                    "title": "Own a TurnBerry",
                    "description": "Build a brand people love and bring healthy, delicious acai bowls to your community.",
                    "alt": "TurnBerry Acai Franchise Opportunity"
                },
                "about": {
                    "title": "Our mission",
                    "header_1": "Behind the Berry Best Acai",
                    "description": "To create meaningful community impact: one acai bowl at a time, by delivering high-quality products and building genuine human connection in every market we serve.",
                    "header_2": "Strategic Intent",
                    "intents": {
                        "intent_1": "Build a lifestyle brand anchored in wellness & joy",
                        "intent_2": "Become the leading premium acai brand in Canada and beyond",
                        "intent_3": "Influence culture through community, digital presence, and franchise excellence"
                    }
                },
                "location_standards": {
                    "title": "Location Standards",
                    "size": {
                        "title": "Location Size",
                        "minimum": "Minimum of 300 sq. ft.",
                        "maximum": "Maximum of 1,000 sq. ft."
                    },
                    "locations": {
                        "title": "Locations",
                        "description": "Close-to-home or on the way to work locations are paramount to take advantage of the important food on-the-go category."
                    },
                    "header": "Choose Your Perfect Fit",
                    "description": "We offer three flexible franchise formats designed to match your ambition and market.",
                    "formats": {
                        "kiosk": {
                            "title": "Kiosk",
                            "description": "Perfect for high-traffic malls and quick service. Streamlined operations for maximum customer flow."
                        },
                        "flagship": {
                            "title": "Flagship Store",
                            "description": "The ultimate TurnBerry experience. Ideal for lifestyle districts and community hubs with full seating."
                        },
                        "standalone": {
                            "title": "Standalone Location",
                            "description": "Become a neighborhood staple. Perfect for local market dominance with dedicated parking."
                        }
                    }
                },
                "process": {
                    "title": "Your Turnkey Business",
                    "description": "We provide the brand, systems, and support. You provide the passion and local expertise. Together, we build something amazing.",
                    "steps": {
                        "rd_menu": {
                            "name": "R&D & Menu",
                            "description": "Proven recipes and continuous product innovation."
                        },
                        "branding_marketing": {
                            "name": "Brand & Marketing",
                            "description": "Complete brand guidelines and marketing toolkits."
                        },
                        "training_support": {
                            "name": "Training & Support",
                            "description": "Comprehensive training and ongoing operational support."
                        },
                        "supply_chain": {
                            "name": "Supply Chain",
                            "description": "Reliable suppliers and streamlined inventory management."
                        },
                        "tech_stack": {
                            "name": "Tech Stack",
                            "description": "POS systems, ordering apps, and performance analytics."
                        },
                        "operations_manual": {
                            "name": "Operations Manual",
                            "description": "Step-by-step processes for efficient daily operations."
                        }
                    }
                },
                "locations": {
                    "title": "Our Locations",
                    "description": "Find your nearest TurnBerry and step into a world of açai, soft glow lighting, and the vibe you didn't know you needed."
                },
                "cta": {
                    "title": "Ready to bring the berry best to your city?",
                    "description": "Join Canada's fastest-growing açaí brand and build something meaningful.",
                    "image_alt": "TurnBerry Acai"
                }
            }
        },
        "components": {
            "store_locator": {
                "search": {
                    "placeholder": "Search by store name, address, or city...",
                    "location_button_loading": "Getting Location...",
                    "location_button": "Use My Location"
                },
                "filters": {
                    "brand_placeholder": "Select Brand",
                    "brand_all": "All Brands",
                    "province_placeholder": "Select Province",
                    "province_all": "All Provinces",
                    "clear_filters": "Clear Filters",
                    "clear_filters_title": "Clear all filters"
                },
                "results": {
                    "showing": "Showing {filtered} of {total} stores",
                    "sorted_by_distance": "Sorted by distance"
                },
                "empty_state": {
                    "no_stores_title": "No stores found",
                    "no_stores_description": "Try adjusting your search or filters"
                }
            }
        },
        "crm": {
            "leads": {
                "actions": {
                    "request_information": "Request Information",
                    "save_changes": "Save Changes",
                    "submit_lead": "Submit Lead"
                },
                "admin": {
                    "create": {
                        "modal_success": "Thanks for the submission. The details have been recorded in the CRM.",
                        "page_subtitle": "Capture prospective franchisee details and route them directly into the CRM.",
                        "page_title": "CRM Lead Generation"
                    },
                    "edit": {
                        "back_to_details": "Back to lead details",
                        "description": "Update the information captured for this lead.",
                        "heading": "Edit Lead",
                        "notes_placeholder": "Add any relevant notes or follow-up details",
                        "page_title": "Edit Lead #{id}",
                        "qualified_label": "Lead is qualified"
                    },
                    "index": {
                        "description": "Track all submitted leads and monitor their follow-up status.",
                        "empty": "No leads found yet.",
                        "headers": {
                            "deposit": "Deposit",
                            "email": "Email",
                            "name": "Name",
                            "phone": "Phone",
                            "qualified": "Qualified",
                            "source": "Source",
                            "status": "Status",
                            "submitted": "Submitted"
                        },
                        "new_lead": "New Lead",
                        "title": "CRM Leads"
                    },
                    "show": {
                        "interested_brands": "Interested Brands",
                        "lead_management": "Lead Management",
                        "notes_placeholder": "Add any follow-up details here",
                        "page_title": "Lead #{id}",
                        "submitted_at": "Submitted {date}"
                    }
                },
                "fields": {
                    "area_of_interest": {
                        "label": "Which area are you interested in?",
                        "placeholder": "City, Province or Region"
                    },
                    "badge_number": {
                        "label": "Badge Number (optional)",
                        "placeholder": "Enter badge number if applicable"
                    },
                    "current_occupation": {
                        "label": "What is your current occupation?"
                    },
                    "deposit": {
                        "label": "Deposit Amount",
                        "placeholder": "0.00"
                    },
                    "email": {
                        "label": "Email",
                        "placeholder": "name{'@'}example.com"
                    },
                    "full_name": {
                        "label": "Full Name"
                    },
                    "intended_role": {
                        "label": "What role do you intend to take?",
                        "placeholder": "Owner-operator, investor, partner, etc."
                    },
                    "interested_brands": {
                        "help": "Select one or more brands.",
                        "label": "Which brand are you interested in?"
                    },
                    "launch_timing": {
                        "label": "When do you want to launch your business?",
                        "placeholder": "Select timing"
                    },
                    "liquid_capital": {
                        "label": "How much liquid capital do you have to invest?",
                        "placeholder": "Select an amount range"
                    },
                    "notes": {
                        "internal_placeholder": "Add any internal notes or follow-up actions",
                        "label": "Notes"
                    },
                    "phone_number": {
                        "label": "Phone Number",
                        "placeholder": "+1 (514) 555-1234"
                    },
                    "qualified": {
                        "label": "Qualified"
                    },
                    "source": {
                        "label": "Source of Input",
                        "placeholder": "Select a source"
                    },
                    "status": {
                        "label": "Status"
                    }
                },
                "messages": {
                    "created": "Your submission was successful.",
                    "updated": "Your submission was updated successfully."
                },
                "options": {
                    "launch_timing": {
                        "one_year_or_more": "1 year or more",
                        "six_to_twelve_months": "6 to 12 months",
                        "three_to_six_months": "3 to 6 months",
                        "within_3_months": "Within 3 months"
                    },
                    "liquid_capital": {
                        "100k-150k": "$100,000 - $150,000",
                        "150k-200k": "$150,000 - $200,000",
                        "200k-300k": "$200,000 - $300,000",
                        "300k-400k": "$300,000 - $400,000",
                        "400k-500k": "$400,000 - $500,000",
                        "50k-100k": "$50,000 - $100,000",
                        "500k+": "$500,000+"
                    },
                    "sources": {
                        "franchise_expo": "Franchise Expo",
                        "meta": "Meta (Facebook\/Instagram)",
                        "tiktok": "TikTok",
                        "web_inquiry": "Web Inquiry",
                        "youtube": "YouTube"
                    },
                    "status": {
                        "closed": "Closed",
                        "contacted": "Contacted",
                        "new": "New",
                        "pending_deposit": "Pending Deposit"
                    }
                },
                "public": {
                    "modal_success": "Thanks! Our team will reach out shortly.",
                    "page_subtitle": "Complete this form to connect with our franchising team.",
                    "page_title": "Franchise Expo"
                },
                "shared": {
                    "back_to_leads": "Back to leads",
                    "modal": {
                        "default_message": "Thanks for the submission. The details have been recorded in the CRM.",
                        "title": "Success!",
                        "redirect_message": "You will be redirected to the lead list in 5 seconds, or use the button below to go now.",
                        "redirect_now": "Go to leads now"
                    },
                    "no_notes_recorded": "No notes recorded yet.",
                    "none_provided": "None provided",
                    "unknown_value": "--"
                }
            }
        },
        "franchise": {
            "title": "Become our partner",
            "information_request": "Information request",
            "manage_booking_title": "Manage your booking",
            "information_request_description": "Please answer the following questions, which will help us determine if you are a qualified potential franchisee.",
            "form": {
                "referrer": "Referrer",
                "name": "Name",
                "date_of_birth": "Date of Birth",
                "phone_number": "Phone Number",
                "email": "Email",
                "interested_brands": "Which brands interest you the most?",
                "investments": "How much do you have available to invest?",
                "project_details": "Your project",
                "financial_details": "Your investment",
                "select_option": "Select an option",
                "qualification": {
                    "not_provided": "Not provided",
                    "needs_loan": {
                        "question": "Will you need a loan?",
                        "options": {
                            "yes": "Yes",
                            "no": "No",
                            "not_sure": "Not sure"
                        }
                    },
                    "credit_score_range": {
                        "question": "What is your approximate credit score?",
                        "options": {
                            "below_600": "Below 600",
                            "600_659": "600–659",
                            "660_699": "660–699",
                            "700_749": "700–749",
                            "750_plus": "750+",
                            "unknown": "I don’t know"
                        }
                    },
                    "residency_status": {
                        "question": "Are you a Canadian citizen or permanent resident?",
                        "options": {
                            "canadian_citizen": "Canadian citizen",
                            "permanent_resident": "Permanent resident",
                            "neither": "Foreign national",
                            "not_sure": "Not sure"
                        }
                    },
                    "relevant_experience": {
                        "question": "Do you have experience relevant to this franchise?",
                        "options": {
                            "yes": "Yes",
                            "no": "No",
                            "not_sure": "Not sure"
                        }
                    },
                    "has_partners": {
                        "question": "Will any partners join you on this project?",
                        "options": {
                            "yes": "Yes",
                            "no": "No",
                            "not_sure": "Not sure"
                        }
                    }
                },
                "area_of_interest": "In which location are you looking to open a franchise?",
                "launch_timing": {
                    "question": "When would you like to launch your franchise?",
                    "within_3_months": "Within the next 3 months",
                    "3_to_6_months": "3 to 6 months",
                    "6_to_12_months": "In 6 to 12 months",
                    "1_year_or_more": "In 1 year or more"
                },
                "who_is_the_operator": {
                    "question": "Will you operate the business yourself?",
                    "myself": "Myself",
                    "someone_else": "Someone else"
                },
                "address": "Address",
                "city": "City",
                "province": "Province",
                "postal_code": "Postal Code",
                "education": "Education",
                "work_experience": "Work experience",
                "current_income": "Current employment income",
                "other_income": "Other source of income",
                "specify_other_income": "If other income, please specify",
                "bank": "Financial institution(s) where you do business",
                "branch": "Branch",
                "criminal_record": "Have you ever been convicted of a crime?",
                "franchise_will_be_the_only_source_of_revenue": "Is your franchise your only source of income?",
                "total_assets": "Total assets",
                "total_debts": "Total debts",
                "minus": "Minus",
                "net_worth": "Net worth",
                "amount_available_for_investment": "Amount available for investment",
                "financing_source": "Source of financing for your franchise",
                "credit_rating": "Credit rating",
                "opening_date": "If your application is successful, when would you be ready to purchase your franchise?",
                "location": "Where you would like to operate your franchise",
                "operator": "Are you planning to operate your franchise yourself?",
                "if_not_operator": "If not, who will you entrust with the day-to-day management of your franchise?",
                "short_training": "Will you be available 2 weeks full time before the opening or takeover of your restaurant to be trained in an existing restaurant, even if you wish to entrust your day-to-day operations to someone else?",
                "long_training": "Will you be available 2 weeks full time before the opening or takeover of your restaurant to be trained in an existing restaurant, even if you wish to entrust your day-to-day operations to someone else?",
                "other_party": "Indicate, in the space provided, the names of any other persons who will be involved in the operation of your franchise. If any of these persons are required to sign the Franchise Agreement, have them complete a Request for Information form.",
                "yes": "Yes",
                "no": "No",
                "newsletter": "I agree to receive electronic communication from Franchiseur via e-mail and\/or text message.",
                "terms": "I agree that the information submitted will be used for business development purposes. A representative may contact you via phone and\/or email to discuss relevant opportunities. For more details, please refer to our Privacy Policy.",
                "schedule": {
                    "prompt": "Would you like to schedule a call with us?",
                    "description": "Choose an available day and a preferred time period.",
                    "date_label": "Call date",
                    "period_label": "Preferred time",
                    "current_booking_title": "Current booking",
                    "current_booking_description": "This is your scheduled call. You can choose a different date or period if needed.",
                    "current_booking_missing": "No booking details available",
                    "reschedule_button": "Reschedule",
                    "update_booking": "Update booking",
                    "select_date": "Select a date",
                    "select_period": "Select a time",
                    "loading": "Loading available times...",
                    "load_error": "We could not load the available times for this date. Please choose another date or try again.",
                    "available_spots": "{count} spots available",
                    "full": "Fully booked",
                    "unavailable": "Unavailable",
                    "unavailable_error": "That call time is no longer available. Please choose another time.",
                    "lead_time_unavailable": "Requires {hours} hours notice",
                    "lead_time_error": "Please choose a call time at least {hours} hours from now.",
                    "email_requested": "Requested a call",
                    "periods": {
                        "morning": "Morning",
                        "afternoon": "Afternoon",
                        "evening": "Evening"
                    }
                },
                "submit": "Send Inquiry"
            },
            "success": "Your request has been sent!",
            "success_message": "We received your request and will be in touch soon.",
            "success_scheduled_message": "Your call is confirmed. We look forward to speaking with you on:",
            "return_home": "Return home",
            "call_confirmation": {
                "email": {
                    "subject": "Your Franchiseur call is scheduled",
                    "greeting": "Hello {name},",
                    "intro": "Your call with Franchiseur has been scheduled. The details are below.",
                    "manage_booking_button": "Manage your booking",
                    "signoff": "Thanks,"
                },
                "sms": {
                    "confirmation": "Franchiseur: your call is scheduled for {date} ({period}). Manage your booking here: {url}",
                    "reminder": "Franchiseur reminder: your call is tomorrow, {date} ({period}). Manage your booking here: {url}"
                }
            },
            "admin_call_availability": {
                "title": "Call Availability",
                "description": "Manage the default weekly call capacity and date-specific overrides.",
                "weekly_defaults": "Weekly defaults",
                "date_overrides": "Date overrides",
                "enabled": "Enabled",
                "capacity": "Capacity",
                "save_defaults": "Save defaults",
                "add_override": "Add override",
                "date": "Date",
                "period": "Period",
                "no_overrides": "No date overrides have been created.",
                "remove_override": "Remove",
                "messages": {
                    "updated": "Call availability has been updated.",
                    "override_saved": "Call availability override has been saved.",
                    "override_deleted": "Call availability override has been deleted."
                }
            },
            "admin_inquiries": {
                "index": {
                    "title": "Inquiries",
                    "description": "Review franchise inquiries.",
                    "headers": {
                        "name": "Name",
                        "email": "Email",
                        "phone": "Phone",
                        "booking": "Booking",
                        "submitted": "Submitted",
                        "actions": "Actions"
                    },
                    "empty": "No inquiries have been submitted yet."
                },
                "show": {
                    "page_title": "Inquiry #{id}",
                    "back_to_inquiries": "Back to inquiries",
                    "submitted_at": "Submitted {date}",
                    "contact_details": "Contact details",
                    "inquiry_details": "Inquiry details",
                    "booking_details": "Booking details",
                    "language": "Language",
                    "reminder_sent": "Reminder sent",
                    "none_provided": "None provided",
                    "save_booking": "Save booking"
                },
                "booking": {
                    "status": "Booking status",
                    "not_requested": "No call requested",
                    "requested": "Call requested",
                    "scheduled_short": "{date}, {period}"
                },
                "messages": {
                    "booking_updated": "Booking details have been updated.",
                    "booking_cleared": "Booking details have been cleared."
                }
            }
        },
        "franchise_show": {
            "meta_title": "Franchise Show — You’re invited",
            "event": "Franchise Show",
            "headline": "You’re invited.",
            "booths": "Meet us at booths",
            "description": "Come meet the Franchiseur team, discover our brands, and explore your next business opportunity.",
            "tickets": "Get free tickets",
            "brands_title": "Discover our brands.",
            "brands_description": "Nine brands. A world of possibilities. Find the one that speaks to you.",
            "closing_title": "Let’s meet at the show.",
            "closing_description": "Your next chapter could start with a conversation. We’ll see you at booths 501–502."
        },
        "franchiseur": {
            "intro": {
                "subtitle": "Seize the Opportunity of a Lifetime",
                "title": "Empowering Success with Proven Franchising Systems",
                "description": "At Franchiseur, we offer a path to success through our thriving successful business models for entrepreneurs and business enthusiasts.<br \/><br \/>\nCreate and develop your legacy with our proven and verified brands. Start your entrepreneurial adventure with us.",
                "cta": "Let's talk"
            },
            "portfolio": {
                "title": "Our Proven Portfolio of Performing Franchises",
                "description": "With a grand network of thriving franchises across multiple key locations, Franchiseur’s success shows the power of a proven, passion-driven model in diverse markets and industries.<br \/><br \/>\nReady to join a top-performing franchise brand built for success?",
                "cta": "I'm Interested"
            },
            "steps": {
                "title": "Becoming a Franchise Owner",
                "step01": {
                    "title": "Application & Introduction",
                    "description": "Start your journey by filling out a quick online application form. We'll review your experience and background to ensure a strong match your the desired franchise."
                },
                "step02": {
                    "title": "Interview & Assessment",
                    "description": "Let's get in touch, discuss goals, motivations, and vision, and review your questions before conducting a financial assessment."
                },
                "step03": {
                    "title": "Approval, Discovery & Onboarding",
                    "description": "Once you’ve been given the green light, you'll sign the franchise agreement to join us. Our team will provide on-site training and integration programs to set you up for success."
                }
            },
            "interviews": {
                "title": "Behind the Empire",
                "description": "Discover exclusive interviews with Jim Cam as he shares his journey from startup to building a franchise empire. Hear firsthand insights on restaurant business strategies, franchise management, and entrepreneurial success stories."
            },
            "behind_the_business": {
                "title": "Behind the Business",
                "description": "Discover real-world stories and expert guidance on mastering the franchise model with Jim Cam, offering a clear, honest look at what it really takes to build, grow, and run a successful franchise."
            }
        },
        "legal": {
            "privacy_policy": "Privacy Policy",
            "terms_of_service": "Terms of Service",
            "privacy": "Privacy",
            "terms": "Terms"
        },
        "location": {
            "add_exception": "Add Exception",
            "add_time_slot": "Add Time Slot",
            "business_hours": "Business Hours",
            "closed_indefinitely": "Closed Indefinitely",
            "closed_no_specified_time": "If no hours are specified, the location is considered closed that day.",
            "closed": "Closed",
            "closing_soon": "Closing Soon",
            "exceptions_description": "Specific dates or periods with adjusted hours, differing from the regular schedule (e.g., holidays, closures, or extended hours).",
            "exceptions": "Exceptions",
            "find_location": "Find a Location",
            "find_us": "Find Us",
            "get_directions": "Get Directions",
            "location_search": "Search by address, postal code or city",
            "open_at": "Open {datetime}",
            "open_until": "Open until {datetime}",
            "open": "Open",
            "order_online": "Order Online",
            "reason": "Reason",
            "regular_hours_description": "Consistent weekly operating hours that remain the same every week.",
            "regular_hours": "Regular Hours",
            "store_info": "Store Info",
            "store": "Store",
            "view_all_locations": "View all locations",
            "search": {
                "placeholder": "Search by store name, address, or city...",
                "location_button_loading": "Getting Location...",
                "location_button": "Use My Location"
            },
            "filters": {
                "brand_placeholder": "Select Brand",
                "brand_all": "All Brands",
                "province_placeholder": "Select Province",
                "province_all": "All Provinces",
                "clear_filters": "Clear Filters",
                "clear_filters_title": "Clear all filters"
            },
            "results": {
                "showing": "Showing {filtered} of {total} stores",
                "sorted_by_distance": "Sorted by distance"
            },
            "empty_state": {
                "no_stores_title": "No stores found",
                "no_stores_description": "Try adjusting your search or filters"
            }
        },
        "navigation": {
            "about": "About",
            "account_settings": "Account Settings",
            "account": "Account",
            "behind_the_business": "Behind the business",
            "book_a_all": "Get Started",
            "brands": "Brands",
            "business_hours": "Business Hours",
            "business_opportunities": "Business Opportunities",
            "categories": "Categories",
            "close_menu": "Close Menu",
            "close_sidebar": "Close Side Navigation",
            "coupons": "Coupons",
            "customers": "Customers",
            "dashboard": "Dashboard",
            "find_us": "Find Us",
            "franchise_expo": "Franchise Expo",
            "franchises": "Franchises",
            "franchising": "Franchising",
            "interviews": "Interviews",
            "jobs": "Jobs",
            "language_selector": "Language Selector",
            "locations": "Locations",
            "menu": "Menu",
            "my_orders": "My Orders",
            "open_menu": "Open Menu",
            "open_sidenav": "Open Side Navigation",
            "order_online": "Order Online",
            "order": "Order",
            "orders": "Orders",
            "our_brands": "Our Brands",
            "overview": "Overview",
            "partnership": "Partnership",
            "private_event": "Private Event",
            "products": "Products",
            "profile": "Profile",
            "promotions": "Promotions",
            "settings": "Settings",
            "training": "Training"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "payment": {
            "balance_owed": "Balance Owed",
            "card_number": "Card Number",
            "cash": "Cash",
            "credit_card": "Credit Card",
            "credit_debit": "Credit and Debit",
            "cvc": "Security Code",
            "debit_card": "Debit Card",
            "expiration": "Expiration Date",
            "gift_card": "Gift Card",
            "name_on_card": "Name on Card",
            "paid_by": "Paid by",
            "pay_at_restaurant": "Pay at the restaurant",
            "payment_method": "Payment Method",
            "payment_summary": "Payment Summary",
            "save_card": "Save payment method for future use",
            "ending": "Ending {last4}",
            "expires": "Expires {month} \/ {year}",
            "success": "Payment processed successfully!",
            "refund_success": "Refund processed successfully!",
            "capture_success": "Payment captured successfully!",
            "pending": "Payment is being processed. Please check back later.",
            "requires_action": "Additional verification required. Please complete the payment authentication.",
            "generic_error": "An error occurred while processing your payment. Please try again.",
            "card_declined": "Your card was declined. Please try another payment method.",
            "expired_card": "Your card has expired. Please try another payment method.",
            "incorrect_cvc": "The CVC number is incorrect. Please check your card details."
        },
        "privateevent": {
            "meta_title": "Private Event",
            "headline": "Your chance to meet The Franchiseur",
            "description": "Grab the limited t-shirt during our 24-hour launch. Every t-shirt is your ticket to a private networking event with Jim Cam, The Franchiseur.",
            "target_launch": "Target launch: {date}",
            "fallback_launch": "Set SHOP_LAUNCH_AT in your .env to sync the exact moment.",
            "launch_live": {
                "title": "The shop is now open for 24 hours only.",
                "body": "Step into the one-day-only drop while it is live—once the window closes, it is gone.",
                "cta": "Enter the shop"
            },
            "ended": {
                "title": "The Private Event sale has ended.",
                "body": "The 24-hour window closed on {date}. Thank you to everyone who joined the drop.",
                "cta": "View products"
            },
            "ends_heading": "Sale ends in",
            "countdown": {
                "days": "Days",
                "hours": "Hours",
                "minutes": "Minutes",
                "seconds": "Seconds"
            },
            "form": {
                "placeholder": "Enter your email for launch updates",
                "button": "Subscribe",
                "success": "Thanks! You will hear from us on launch day."
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "accepted_if": "The {attribute} must be accepted when {other} is {value}.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when {other} is {value}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal to {value}.",
                "file": "The {attribute} must be greater than or equal to {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal to {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal to {value}.",
                "file": "The {attribute} must be less than or equal to {value} kilobytes.",
                "string": "The {attribute} must be less than or equal to {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "mac_address": "The {attribute} must be a valid MAC address.",
            "max": {
                "numeric": "The {attribute} must not be greater than {max}.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "string": "The {attribute} must not be greater than {max} characters.",
                "array": "The {attribute} must not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "phone": "The {attribute} field must be a valid number.",
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "recaptcha": "reCAPTCHA validation failed. Please verify that you are not a robot and try again.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} must be a valid URL.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "business_listing": {
            "dashboard": {
                "title": "Business Listings Dashboard",
                "description": "Manage your business listings and track performance",
                "create_listing": "Create Listing",
                "stats": {
                    "total_listings": "Total Listings",
                    "active_listings": "Active Listings",
                    "total_views": "Total Views",
                    "inquiries": "Inquiries",
                    "favorites": "Favorites"
                },
                "table": {
                    "listing": "Listing",
                    "status": "Status",
                    "price": "Price",
                    "creator": "Creator",
                    "views": "Views",
                    "inquiries": "Inquiries",
                    "favorites": "Favorites",
                    "created": "Created",
                    "actions": "Actions",
                    "view": "View",
                    "analytics": "Analytics",
                    "edit": "Edit",
                    "delete": "Delete",
                    "no_listings_found": "No listings found",
                    "create_first_listing": "Create your first listing"
                },
                "analytics": "Analytics",
                "track_performance": "Track your listing performance",
                "total_page_views": "Total page views",
                "messages_received": "Messages received",
                "users_interested": "Users interested",
                "page_views": "Page Views",
                "users_who_viewed": "Users who viewed your listing",
                "user": "User",
                "date": "Date",
                "message": "Message",
                "status": "Status",
                "messages_from_buyers": "Messages from potential buyers",
                "users_who_favorited": "Users who added your listing to favorites",
                "no_views_yet": "No views yet",
                "no_inquiries_yet": "No inquiries yet",
                "no_favorites_yet": "No favorites yet",
                "inquiry_details": "Inquiry details",
                "preferred_contact_time": "Preferred contact time"
            },
            "index": {
                "title": "Business Listings",
                "results_count": "No business found|1 business found|{count} businesses found",
                "no_businesses_found": "No businesses found",
                "adjust_search_criteria": "Try adjusting your search criteria",
                "clear_all_filters": "Clear All Filters",
                "similar_businesses": "Similar Businesses",
                "favorites": "My Favorites",
                "no_favorites_yet": "You haven't added any listings to your favorites yet.",
                "browse_listings": "Browse Listings",
                "remove_from_favorites": "Remove From Favorites"
            },
            "form": {
                "business_name": "Business Name",
                "description": "Description",
                "industry": "Industry",
                "asking_price": "Asking Price ($)",
                "square_footage": "Square Footage",
                "year_established": "Year Established",
                "business_type": "Business Type",
                "street_number": "Street Number",
                "street_name": "Street Name",
                "city": "City",
                "province": "Province",
                "country": "Country",
                "postal_code": "Postal Code",
                "latitude": "Latitude",
                "longitude": "Longitude",
                "publish_listing": "Publish Listing",
                "publish_date": "Publish Date",
                "pick_a_date": "Pick a date",
                "images": "Images",
                "featured_listing": "Featured Listing",
                "required": "Required",
                "enter_business_name": "Enter business name",
                "describe_your_business": "Describe your business...",
                "select_industry": "Select industry",
                "enter_asking_price": "Enter asking price",
                "enter_square_footage": "Enter square footage",
                "enter_years_established": "Enter years established",
                "select_business_type": "Select business type",
                "enter_street_number": "Enter street number",
                "enter_street_name": "Enter street name",
                "enter_city": "Enter city",
                "select_province": "Select province",
                "enter_country": "Enter country",
                "enter_postal_code": "Enter postal code",
                "enter_latitude": "Enter latitude",
                "enter_longitude": "Enter longitude",
                "select_status": "Select status",
                "status": "Status",
                "location": "Location"
            },
            "business_types": {
                "franchise": "Franchise",
                "independent": "Independent Business",
                "established": "Established Business"
            },
            "statuses": {
                "draft": "Draft",
                "published": "Published",
                "sold": "Sold",
                "closed": "Closed"
            },
            "filters": {
                "search_businesses": "Search businesses...",
                "all_industries": "All Industries",
                "all_provinces": "All Provinces",
                "min_price": "Min Price",
                "max_price": "Max Price",
                "city": "City",
                "sort_by": "Sort By",
                "newest_first": "Newest First",
                "price_low_to_high": "Price: Low to High",
                "price_high_to_low": "Price: High to Low"
            },
            "image_upload": {
                "drag_and_drop": "Drag and drop images here",
                "click_to_select": "or click to select files",
                "file_types": "PNG, JPG, GIF up to 5MB",
                "uploaded_images": "Uploaded Images",
                "set_primary": "Set Primary",
                "primary": "Primary",
                "remove": "Remove",
                "move_up": "Move Up",
                "move_down": "Move Down",
                "max_images_reached": "You have reached the maximum of {max} images."
            },
            "show": {
                "businesses": "Businesses",
                "description": "Description",
                "business_details": "Business Details",
                "years": "years",
                "sq_ft": "sq. ft.",
                "contact_broker": "Contact Us",
                "send_message_about": "Send a message about \"{title}\"",
                "message_placeholder": "I'm interested in learning more about this business...",
                "select_best_times": "Select best times to contact",
                "share_via_email": "Share via Email",
                "copy_link": "Copy Link",
                "share_on_facebook": "Share on Facebook",
                "share_on_twitter": "Share on Twitter",
                "print": "Print",
                "best_time_to_contact": "Best Time to Contact",
                "weekday_am": "Weekday AM",
                "weekday_pm": "Weekday PM",
                "weekend_am": "Weekend AM",
                "weekend_pm": "Weekend PM",
                "send_message": "Send Message",
                "image_gallery": "Image Gallery",
                "location": "Location"
            },
            "buttons": {
                "back_to_dashboard": "Back to Dashboard",
                "cancel": "Cancel",
                "create_listing": "Create Listing",
                "save_changes": "Save Changes"
            },
            "messages": {
                "link_copied": "Link copied to clipboard!",
                "inquiry_sent": "Your inquiry has been sent successfully."
            },
            "validation": {
                "required_fields": "Please fill in all required fields.",
                "invalid_email": "Please enter a valid email address."
            }
        }
    },
    "fr": {
        "about_us": {
            "why_we_exist": {
                "title": "Pourquoi Nous Existons",
                "description": "L'objectif de Franchiseur est simple : rendre l'entrepreneuriat accessible, innovant et gratifiant. Nous fournissons aux entrepreneurs ambitieux les ressources et la flexibilité dont ils ont besoin pour créer des entreprises et laisser leur marque.<br \/><br \/>\nAvec chaque marque reconnue pour offrir des expériences de premier ordre, nous offrons plus que des produits et des services ; nous créons des relations durables avec nos clients et nos partenaires franchisés, en veillant à ce que chaque franchisé ait le soutien nécessaire pour se développer durablement dans le marché actuel en évolution rapide.",
                "business_was_founded": "L'entreprise a été fondée",
                "people_on_the_team": "Membres d'équipe",
                "locations": "Emplacements",
                "yearly_revenue": "Revenus Annuels"
            },
            "our_history": {
                "title": "Notre Histoire"
            },
            "who_is_franchiseur": {
                "title": "Qui est le Franchiseur",
                "description": "Depuis plus de 12 ans, Jim Cam, le visionnaire connu sous le nom de Franchiseur, transforme les industries et crée des modèles d'affaires durables. Avec plus de 100 établissements au Canada, Jim a créé un réseau de franchises de marques fiables et prospères fondées sur la confiance, la diversité, l'innovation et l'autonomisation des entrepreneurs.<br \/><br \/>\nSon histoire est celle d'une résilience, qu'il a apprise par l'expérience pratique et par un engagement inflexible en faveur de la croissance et de l'excellence à long terme. Le leadership de Jim donne la priorité à la réussite des franchisés pour qu'ils prospèrent non seulement aujourd'hui, mais aussi pour relever les défis de demain. Avec Franchiseur, Jim a établi un héritage durable qui continue à façonner le monde "
            },
            "our_values": {
                "title": "Nos valeurs",
                "value_1": "Responsabilisation et réussite des franchisés",
                "value_description_1": "Nous nous engageons à fournir aux franchisés les connaissances, les outils et la liberté nécessaires pour prospérer sur le marché actuel. Leur réussite entrepreneuriale alimente notre croissance commune et notre excellence.",
                "value_2": "Flexibilité et croissance",
                "value_description_2": "Nous acceptons le changement et donnons à nos franchisés les moyens de rester à l'avant-garde des tendances et des défis du marché dans des secteurs qui évoluent rapidement. L'adaptabilité de notre approche garantit à la fois la viabilité à long terme et l'expansion durable.",
                "value_3": "Collaboration, travail d'équipe et intégrité",
                "value_description_3": "Nous cultivons une culture transparente et collaborative où les franchisés, les employés et les équipes s'unissent pour un succès partagé."
            }
        },
        "account": {
            "home": "Accueil",
            "profile": "Profil",
            "qr_code": "Code",
            "settings": "Réglages",
            "change_password": "Changer le mot de passe",
            "change_password_description": "Un mot de passe sécurisé contribue à protéger votre compte.",
            "qr_header": "Gagnez et sauvegarder avec votre code.",
            "qr_description": "Montrez ce code QR à notre équipe pour accéder à votre compte.",
            "account_information": "Informations sur le compte",
            "update_account_description": "Mettre à jour les informations du profil de votre compte",
            "delete_account": "Supprimer le compte",
            "delete_account_disclaimer": "Une fois votre compte supprimé, toutes ses données seront définitivement supprimées. Avant de supprimer votre compte, veuillez sauvegarder une copie de toutes les données ou informations que vous souhaitez conserver.",
            "delete_account_confirmation": "Êtes-vous certain de vouloir supprimer votre compte ?",
            "delete_account_instructions": "Une fois que votre compte est supprimé, toutes ses données seront définitivement supprimées. Veuillez saisir votre mot de passe pour confirmer que vous souhaitez supprimer définitivement votre compte.",
            "account": "Compte",
            "account_settings": "Paramètres du compte",
            "my_account": "Mon compte",
            "my_profile": "Mon Profil",
            "my_profile_description": "Ces informations permettront d'identifier vos commandes.",
            "social_login": "Continuer avec {social_media}",
            "or": "ou",
            "name": "Nom",
            "first_name": "Prénom",
            "last_name": "Nom",
            "email": "Adresse courriel",
            "email_or_phone": "Adresse courriel ou Numéro de téléphone",
            "password": "Mot de passe",
            "confirm_password": "Confirmez le mot de passe",
            "forgot_password": "Mot de passe oublié",
            "current_password": "Mot de passe actuel",
            "new_password": "Nouveau mot de passe",
            "phone_number": "Numéro de téléphone",
            "remember_me": "Se souvenir de moi",
            "new_user": "Nouvel utilisateur?",
            "existing_user": "Vous avez déjà un compte?",
            "welcome": "Bienvenue, {name}",
            "almost_there": "Vous y êtes presque!",
            "reset_password": "Réinitialiser le mot de passe",
            "verify": "Verify Phone Number",
            "otp": "Entrez le code à 6 chiffres qui vous a été envoyé.",
            "newsletter": "Je souhaite m'inscrire sur la liste VIP pour bénéficier d'un accès exclusif aux promotions et rabais.",
            "terms_and_conditions": {
                "agree": "En cochant cette case, je confirme que j'ai lu et que j'accepte les",
                "and": "et la"
            },
            "success_messsage": {
                "account": "Votre profil a été mis à jour avec succès",
                "password": "Votre mot de passe a été modifié avec succès",
                "payment": {
                    "create": "Votre mode de paiement a été enregistré avec succès",
                    "update": "Votre mode de paiement a été mise à jour avec succès",
                    "delete": "Votre mode de paiement a été supprimé avec succès"
                },
                "address": {
                    "create": "Votre adresse a été enregistré avec succès",
                    "update": "Votre adresse a été mise à jour avec succès",
                    "delete": "Votre adresse a été supprimé avec succès"
                }
            }
        },
        "actions": {
            "accept": "Accepter",
            "add_exception": "Ajouter une exception",
            "add_time_slot": "Ajouter une plage horaire",
            "add": "Ajouter",
            "agree": "Accepter",
            "apply": "Appliquer",
            "back": "Retour",
            "begin": "Début",
            "by": "par",
            "cancel": "Annuler",
            "change": "Modifier",
            "checkout": "Commander",
            "close": "Fermer",
            "collapse": "Réduire",
            "confirm": "Confirmer",
            "confirmation": {
                "delete": "Êtes-vous certains de vouloir supprimer? Cette action est permantente",
                "submit": "Confirmez la soumission?",
                "update": "Confirmez la mise à jour?"
            },
            "create": "Créer",
            "decline": "Refuser",
            "delete": "Supprimer",
            "delete_account": "Supprimer le compte",
            "disable": "Désactiver",
            "done": "Terminé",
            "download": "Télécharger",
            "edit": "Modifier",
            "enable": "Activer",
            "end": "Fin",
            "exit": "Quitter",
            "expand": "Étendre",
            "filter": "Filtrer",
            "find": "Trouver",
            "follow": "S'abonner",
            "go": "Aller",
            "help": "Aide",
            "hide_all": "Masquer tout",
            "hide": "Masquer",
            "home": "Accueil",
            "less": "Moins",
            "log_in": "Se connecter",
            "log_out": "Déconnexion",
            "manage": "Faire en sorte",
            "maximize": "Maximiser",
            "minimize": "Minimiser",
            "more": "Plus",
            "new": "Nouveau",
            "next": "Suivant",
            "no_results": "Pas de résultats",
            "no": "Non",
            "off": "Désactivé",
            "okay": "OK",
            "on": "Activé",
            "open": "Ouvrir",
            "other": "Autre",
            "pay": "Payer",
            "pay_now": "Payer maintenant",
            "previous": "Précédent",
            "print": "Imprimer",
            "publish": "Publier",
            "recommend": "Recommander",
            "redo": "Rétablir",
            "refund": "Rembourser",
            "register": "S'inscrire",
            "remove": "Supprimer",
            "reserve": "Réserver",
            "reserve_a_table": "Réserver une table",
            "return": "Retour",
            "save": "Enregistrer",
            "search": "Rechercher",
            "select": "Sélectionner",
            "send": "Envoyer",
            "show_all": "Afficher tout",
            "show": "Afficher",
            "sign_up": "S'inscrire",
            "social_login": "Continuer avec {provider}",
            "start": "Début",
            "stop": "Arrêt",
            "submit_a_ticket": "Soumettre un billet",
            "submit": "Soumettre",
            "subscribe": "S'abonner",
            "undo": "Annuler",
            "unsubscribe": "Se désabonner",
            "update": "Mettre à jour",
            "upload": "Charger",
            "view_all": "Voir tout",
            "view_cart": "Voir le panier",
            "view_menu": "Voir le menu",
            "view_more": "Voir plus",
            "view_order": "Voir la commande",
            "view": "Voir",
            "yes": "Oui"
        },
        "address": {
            "address_line_1": "Adresse",
            "address_line_2": "Appartement, unité, etc.",
            "city": "Ville",
            "province": "Province",
            "state": "État",
            "postal_code": "Code postal",
            "zip_code": "Code zip",
            "country": "Pays",
            "latitude": "Latitude",
            "longitude": "Longitude"
        },
        "auth": {
            "failed": "Ces identifiants ne correspondent pas à nos enregistrements.",
            "password": "Le mot de passe fourni est incorrect.",
            "throttle": "Tentatives de connexion trop nombreuses. Veuillez essayer de nouveau dans {seconds} secondes."
        },
        "brand": {
            "bapbol": {
                "hero_title": "BAP BOL | Bols coréens et franchise",
                "hero_headline": "Les saveurs coréennes dans un bol.",
                "hero_description": "Découvrez un concept moderne qui réunit des saveurs affirmées et la simplicité du quotidien.",
                "hero_alt": "Un bol BAP BOL en sauce avec riz, carottes, chou et nouilles dans un bol en céramique blanche sur une table crème",
                "about": {
                    "section_label": "La marque",
                    "tagline": "La cuisine coréenne moderne, au quotidien.",
                    "description_1": "Fondé à Montréal en 2026, BAP BOL est un concept de restauration rapide décontractée coréenne, construit autour des bols de riz, de saveurs affirmées et d’une expérience accessible.",
                    "description_2": "Des repas complets, des saveurs franches et des ingrédients colorés : le bol est au cœur de notre menu. Préparé sur commande et facile à savourer, il trouve sa place au dîner, au souper ou à emporter."
                },
                "values": {
                    "fresh": {
                        "title": "Frais",
                        "description": "Une préparation soignée et des ingrédients colorés au cœur de chaque bol."
                    },
                    "fast": {
                        "title": "Rapide",
                        "description": "Un format adapté aux rythmes modernes, du dîner express au souper à emporter."
                    },
                    "flavourful": {
                        "title": "Savoureux",
                        "description": "Des saveurs coréennes affirmées qui donnent envie de revenir."
                    },
                    "approachable": {
                        "title": "Accessible",
                        "description": "Une façon simple de découvrir la cuisine coréenne, avec des formats familiers et du choix."
                    }
                },
                "menu": {
                    "tagline": "La cuisine coréenne, autour du bol",
                    "title": "Nos bols coréens signature.",
                    "made_to_order": "Préparé sur commande",
                    "signature_alt": "Quatre bols BAP BOL avec garnitures variées, riz et légumes sur une table en bois aux tons chauds",
                    "categories": {
                        "bulgogi": "Bol bulgogi",
                        "spicy_pork": "Bol de porc épicé",
                        "fried_chicken": "Bol de poulet frit coréen",
                        "teriyaki_chicken": "Bol de poulet soya",
                        "veggie": "Bol végé"
                    },
                    "gallery": {
                        "katsu_kick": {
                            "title": "Katsu Doré",
                            "description": "Poulet katsu pané et croustillant, accompagné de sauce tonkatsu.",
                            "alt": "Katsu Doré avec poulet pané tranché, riz et légumes dans un bol en céramique blanche sur une table en bois"
                        },
                        "mandu_crunch": {
                            "title": "Mandu Croustillant",
                            "description": "Raviolis aux légumes frits et croustillants.",
                            "alt": "Mandu Croustillant avec raviolis en sauce, riz, nouilles et légumes dans un bol en céramique blanche, près d’une serviette et de baguettes"
                        },
                        "seoul_crunch": {
                            "title": "Séoul Croustillant",
                            "description": "Poulet frit coréen, nappé de sauce sucrée et épicée.",
                            "alt": "Séoul Croustillant avec morceaux glacés, riz, nouilles et légumes dans un bol en céramique blanche, avec un verre en arrière-plan"
                        },
                        "smoky_pork": {
                            "title": "Bulgogi Fumé",
                            "description": "Porc bulgogi mariné au soya, savoureux et légèrement sucré.",
                            "alt": "Bulgogi Fumé avec porc tranché, riz, nouilles et légumes dans un bol en céramique blanche, près de baguettes sur un repose-baguettes"
                        },
                        "soy_drip": {
                            "title": "Poulet Soya",
                            "description": "Poulet bulgogi mariné au soya, aux notes sucrées et salées.",
                            "alt": "Poulet Soya avec poulet tranché, riz, nouilles et légumes dans un bol en céramique blanche, près d’une serviette crème et d’un verre d’eau"
                        },
                        "bulgogi_beef": {
                            "title": "Bœuf Bulgogi",
                            "description": "Bœuf BBQ coréen mariné et grillé, aux notes légèrement sucrées.",
                            "alt": "Bœuf Bulgogi avec bœuf tranché, riz, nouilles et légumes dans un bol en céramique blanche, près d’une serviette gris charbon"
                        },
                        "heat_drop": {
                            "title": "Poulet Clash",
                            "description": "Poulet sauté dans une sauce gochujang sucrée et épicée.",
                            "alt": "Poulet Clash avec morceaux en sauce, sésame, riz et légumes dans un bol en céramique blanche, près d’une serviette couleur rouille"
                        },
                        "red_fury": {
                            "title": "Porc Flamme",
                            "description": "Porc sauté au gochujang, entre douceur et piquant.",
                            "alt": "Porc Flamme avec tranches en sauce, riz, nouilles et légumes dans un bol en céramique blanche, près d’une serviette ivoire et de baguettes en métal"
                        },
                        "noodle_flex": {
                            "title": "Nouilles Flex",
                            "description": "Japchae : nouilles de patate douce sautées, légumes et assaisonnement coréen.",
                            "alt": "Nouilles Flex avec nouilles, riz, chou et carottes dans un bol en céramique blanche, près d’une serviette rayée"
                        }
                    },
                    "description": "Généreux, colorés et préparés sur commande. Nos bols signature réunissent les saveurs coréennes dans un repas complet.",
                    "base_title": "Dans chaque bol",
                    "base_description": "Chaque bol est accompagné de riz, de chou napa, de vermicelles de riz et de carottes marinées."
                },
                "support_service": {
                    "title": "Un accompagnement ? chaque ?tape",
                    "subtitle": "De la planification de votre emplacement au soutien de votre ?quipe, d?veloppez votre franchise BAP BOL avec un accompagnement tout au long du parcours.",
                    "image_alt": "Bols BAP BOL et collations cor?ennes",
                    "steps": {
                        "site_selection": {
                            "title": "Choix de l?emplacement",
                            "description": "Un accompagnement pour ?valuer votre emplacement et planifier votre bail."
                        },
                        "financial_support": {
                            "title": "Planification financi?re",
                            "description": "Du soutien pour planifier votre investissement et pr?parer votre plan d?affaires."
                        },
                        "training_program": {
                            "title": "Formation",
                            "description": "Pr?parez votre ?quipe au menu, au service et aux op?rations quotidiennes."
                        },
                        "operational_support": {
                            "title": "Soutien op?rationnel",
                            "description": "Un accompagnement pour assurer la constance de la pr?paration, du service et des op?rations."
                        },
                        "marketing_community": {
                            "title": "Marketing et communaut?",
                            "description": "Planifiez votre lancement et cr?ez des liens avec votre communaut? locale."
                        }
                    }
                },
                "cta": {
                    "title": "Faites découvrir BAP BOL à votre communauté.",
                    "description": "Explorez une franchise de restauration coréenne autour des bols signature, de saveurs affirmées et d’une expérience accessible. Discutez de votre projet avec notre équipe.",
                    "image_alt": "Un bol de poulet tranché avec sésame, riz et légumes sur une table sombre"
                }
            },
            "title": "Devenez propriétaire d'une franchise de",
            "subtitle": "Créez et développez votre héritage, c'est le moment pour vous de faire la différence. Commencez votre aventure entrepreneuriale avec nous.",
            "cta": "Ceci est un aperçu exclusif ! Nous acceptons maintenant les candidatures !",
            "franchise_process": {
                "title": "Service de franchisage clé en main",
                "subtitle": "Nous vous guidons à travers chaque étape du processus",
                "steps": {
                    "lets_talk": {
                        "title": "Parlons-en",
                        "description": "Présentation de la Franchise"
                    },
                    "validation": {
                        "title": "Validation du franchisé",
                        "description": "Dépôt et sélection de l'emplacement"
                    },
                    "rental_research": {
                        "title": "Recherche d'espace de location",
                        "description": "Évaluation et sélection"
                    },
                    "costs_estimation": {
                        "title": "Estimation des coûts",
                        "description": "Plan d'affaires et prêt bancaire"
                    },
                    "incorporation": {
                        "title": "Incorporation",
                        "description": "Rénovation, formation et lancement"
                    }
                },
                "image_alt": "Prochaine étape"
            },
            "franchise_investment": {
                "title": "Frais de franchisage",
                "acquisition_cost": {
                    "title": "Coût d'acquisition de la franchise",
                    "total_investment": "Investissement total : {min}$ - {max}$"
                },
                "requirements": {
                    "title": "Exigences",
                    "down_payment": "Minimum {amount}$ pour la mise de fonds",
                    "credit_score": "Bonne cote de crédit"
                },
                "cta_button": "Demander l'information sur la franchise",
                "fees": {
                    "franchising": "Frais de franchisage unique",
                    "royalties": "Redevances",
                    "marketing": "Frais de marketing",
                    "term": "Durée de la franchise",
                    "years": "ans"
                }
            },
            "onigirishop": {
                "hero_title": "Onigiri Shop - Franchise de Boulettes de Riz Japonaises",
                "hero_alt": "Onigiri Shop",
                "locations": {
                    "title": "Nos franchises",
                    "subtitle_template": "{count} magasins et en croissance à travers le Québec",
                    "cta_title": "Rejoignez notre réseau",
                    "cta_description": "Faites partie de notre famille croissante de partenaires franchisés prospères.",
                    "cta_button": "Commencez votre parcours"
                },
                "delivery_partners": {
                    "title": "Commande en ligne et livraison",
                    "subtitle": "Sushi Sama s'associe avec tous les principaux services de livraison pour offrir des options de commande pratiques",
                    "footer_title": "Stratégie multi-plateformes",
                    "footer_description": "Nous travaillons étroitement avec tous les partenaires des principales plateformes de livraison pour assurer des revenus sains et augmenter l'exposition de la marque sur tous les canaux, offrant aux clients des options de commande pratiques."
                },
                "about": {
                    "tagline": "La tradition rencontre l'innovation pour une expérience culinaire de classe mondiale",
                    "description_1": "Chez <b>Onigiri Shop<\/b>, notre mission est d'introduire les onigiri japonais bien-aimés dans le monde, en ajoutant une touche locale avec des ingrédients frais et innovants. Nous visons à offrir une expérience culinaire accessible, abordable et mondialement reconnue, combinant tradition et créativité.",
                    "description_2": "Nos onigiri offrent une fusion unique de saveurs qui plaît aux goûts divers tout en restant fidèles à ses racines japonaises.",
                    "image_alt": "Préparation d'onigiri"
                },
                "core_values": {
                    "title": "Cinq piliers fondamentaux de succès pour les franchisés",
                    "subtitle": "Nous sommes guidés par cinq valeurs fondamentales",
                    "values": {
                        "quality": {
                            "title": "Qualité",
                            "description": "Nous nous engageons à utiliser les ingrédients les plus frais et de la plus haute qualité pour créer la meilleure expérience onigiri."
                        },
                        "innovation": {
                            "title": "Innovation",
                            "description": "Nous expérimentons constamment avec de nouvelles saveurs et combinaisons, apportant une nouvelle vie à un plat traditionnel."
                        },
                        "collaboration": {
                            "title": "Collaboration",
                            "description": "Nous travaillons étroitement avec nos franchisés, fournisseurs et communautés locales pour construire un réseau solide qui soutient la croissance mutuelle et le succès."
                        },
                        "efficiency": {
                            "title": "Efficacité",
                            "description": "Nous rationalisons nos opérations pour nous assurer que nos restaurants sont à la fois rentables et offrent un service rapide et de haute qualité."
                        },
                        "transparency": {
                            "title": "Transparence",
                            "description": "Nous maintenons une communication claire et ouverte avec nos franchisés, en nous assurant que tous les processus commerciaux sont directs et honnêtes."
                        }
                    },
                    "images": {
                        "quality_alt": "Ingrédients de qualité",
                        "collaboration_alt": "Collaboration d'équipe",
                        "innovation_alt": "Innovation en cuisine",
                        "efficiency_alt": "Opérations efficaces"
                    }
                },
                "menu": {
                    "tagline": "Nos créations d'onigiri les plus populaires",
                    "title": "Nos meilleures ventes",
                    "items": {
                        "spicy_tuna": {
                            "title": "Thon épicé (cru)",
                            "description": "Thon cru, mayo épicée, togarishi",
                            "alt": "Thon épicé cru"
                        },
                        "fresh_salmon": {
                            "title": "Saumon frais (cru)",
                            "description": "saumon cru frais, mayo épicée"
                        },
                        "fuji_mountain": {
                            "title": "Mont fuji",
                            "description": "Saumon frais, crevette kanikama, avocat, varech, fromage grillé, jaunes d'œufs, furikake, tempura",
                            "alt": "Mont fuji"
                        },
                        "shrimp_kanikama": {
                            "title": "Crevette-Kanikama",
                            "description": "crevettes cuites, goberge, mayo kewpie, sauce poke",
                            "alt": "Crevette-Kanikama"
                        },
                        "k_pop": {
                            "title": "K-Pop",
                            "description": "Poulet Frit Coréen, kimchi, fromage grillé, furikake",
                            "alt": "K-Pop et Saumon Deluxe"
                        },
                        "salmon_deluxe": {
                            "title": "Saumon deluxe",
                            "description": "Saumon frais épicé, saumon cuit, ikura, furikake"
                        }
                    },
                    "cta_button": "Voir le menu complet"
                },
                "cta": {
                    "title": "Prêt à commencer votre franchise Onigiri Shop ?",
                    "description": "Rejoignez-nous pour apporter une cuisine de confort japonaise authentique avec des saveurs innovantes aux communautés du monde entier"
                }
            },
            "sushisama": {
                "hero_title": "Sushi Sama - Franchise de Sushi Japonais Moderne",
                "hero_description": "Une tradition japonaise modernisée. Découvrez des sushis authentiques préparés avec finesse et diligence, où chaque rouleau contient des ingrédients uniques qui s'harmonisent parfaitement.",
                "hero_alt": "Sushi Sama",
                "locations": {
                    "title": "Notre réseau en expansion",
                    "subtitle_template": "Marque de franchise basée à Montréal, {count} magasins à travers le Québec et Ottawa",
                    "cta_title": "Rejoignez notre réseau à succès",
                    "cta_description": "Faites partie de la franchise de sushi la plus établie au Québec avec un succès prouvé dans des marchés et des démographies diverses.",
                    "cta_button": "Commencez votre parcours Sushi Sama"
                },
                "delivery_partners": {
                    "title": "Commande en ligne et livraison",
                    "subtitle": "Sushi Sama s'associe avec tous les principaux services de livraison pour offrir des options de commande pratiques",
                    "footer_title": "Stratégie multi-plateformes",
                    "footer_description": "Nous travaillons étroitement avec tous les partenaires des principales plateformes de livraison pour assurer des revenus sains et augmenter l'exposition de la marque sur tous les canaux, offrant aux clients des options de commande pratiques."
                },
                "about": {
                    "tagline": "La tradition rencontre l'innovation pour une expérience culinaire de classe mondiale",
                    "description_1": "Chez <b>Sushi Sama<\/b>, les sushis sont préparés avec finesse et diligence. Chaque rouleau contient des ingrédients uniques qui s'harmonisent parfaitement. Les noms originaux de chaque item reflètent leur contenu et ont été soigneusement créés par des chefs Sushi Sama expérimentés.",
                    "description_2": "Que ce soit pour manger sainement ou pour un événement spécial, vous serez satisfait de votre expérience !",
                    "image_alt": "Préparation de sushi par le chef"
                },
                "menu": {
                    "title": "Notre menu diversifié",
                    "subtitle": "Des sushis traditionnels aux spécialités modernes, nous répondons à tous types de modes de vie et de préférences alimentaires",
                    "categories": {
                        "appetizers": {
                            "title": "Entrées",
                            "description": "Parfaits hors-d'œuvre",
                            "alt": "Entrées"
                        },
                        "chef_specialty": {
                            "title": "Spécialités du chef",
                            "description": "Rouleaux signatures créatifs avec des ingrédients uniques",
                            "alt": "Spécialités du chef"
                        },
                        "nigiri_sashimi": {
                            "title": "Nigiri et Sashimi",
                            "description": "Poisson frais premium servi traditionnellement",
                            "alt": "Nigiri et Sashimi"
                        },
                        "poke_bowls": {
                            "title": "Bols poké",
                            "description": "Bols frais de style hawaïen",
                            "alt": "Bols poké"
                        },
                        "hosomaki": {
                            "title": "Hosomaki",
                            "description": "Rouleaux fins traditionnels",
                            "alt": "Rouleaux Hosomaki"
                        },
                        "bento": {
                            "title": "Boîtes bento",
                            "description": "Repas complets avec riz, salade et plat principal",
                            "alt": "Boîtes bento"
                        },
                        "platters": {
                            "title": "Plateaux",
                            "description": "Assiettes combinées avantageuses",
                            "alt": "Plateaux combo"
                        },
                        "sushi_pizza": {
                            "title": "Pizza sushi",
                            "description": "Innovation fusion",
                            "alt": "Pizza sushi"
                        },
                        "tartare": {
                            "title": "Tartare",
                            "description": "Délicatesse de poisson cru frais",
                            "alt": "Tartare"
                        }
                    },
                    "closing_text_1": "Que nos clients soient en pause déjeuner, au souper, ou qu'ils aient besoin d'une bouchée rapide en déplacement, chacun trouvera quelque chose pour ses besoins et son occasion.",
                    "closing_text_2": "La diversité de notre menu nous permet de répondre à tous types de modes de vie et de préférences alimentaires."
                },
                "franchise_investment": {
                    "why_choose_title": "Pourquoi choisir Sushi Sama ?",
                    "benefits": {
                        "successful_locations": {
                            "title": "{count} emplacements établis",
                            "description": "Historique prouvé à travers le Québec et Ottawa"
                        },
                        "multi_platform": {
                            "title": "Livraison multi-plateformes",
                            "description": "Disponible sur toutes les principales plateformes de livraison"
                        },
                        "flexible_locations": {
                            "title": "Emplacements flexibles",
                            "description": "Loyer abordable et exigences d'espace flexibles"
                        },
                        "delivery_support": {
                            "title": "Support de l'équipe de livraison",
                            "description": "Support complet pour les opérations de livraison"
                        }
                    }
                },
                "cta": {
                    "title": "Prêt à commencer votre franchise Sushi Sama ?",
                    "description": "Rejoignez la franchise de sushi la plus établie au Québec avec {count} emplacements prospères et une approche modernisée de la tradition japonaise.",
                    "image_alt": "Sushi Sama"
                },
                "support_service": {
                    "title": "Notre soutien et service",
                    "subtitle": "Support de franchise complet du début au succès",
                    "image_alt": "Soutien Sushi Sama",
                    "steps": {
                        "site_selection": {
                            "title": "Sélection de site",
                            "description": "Notre équipe expérimentée en immobilier\/développement vous assistera dans la sélection de votre site et la négociation de votre bail."
                        },
                        "financial_support": {
                            "title": "Soutien financier",
                            "description": "Nous travaillons avec vous pour nous assurer que votre institution financière dispose des informations requises. Nous avons un programme de franchise national avec plusieurs coopératives de crédit majeures."
                        },
                        "training_program": {
                            "title": "Programme de formation",
                            "description": "Nous offrons aux franchisés une formation théorique et pratique. Nous soutenons le restaurant avec une équipe de formateurs sur place pour vous aider, vous et votre personnel."
                        },
                        "operational_support": {
                            "title": "Soutien opérationnel",
                            "description": "Notre équipe d'opération dédiée et expérimentée travaille avec le franchisé pour assurer le respect des processus Sushi Sama et des hauts standards."
                        },
                        "marketing_community": {
                            "title": "Communauté très engagée",
                            "description": "Sushi Sama est soutenu par une équipe marketing qui fournit des programmes de marketing local adaptés aux communautés où ils sont situés."
                        }
                    }
                }
            },
            "lepokestation": {
                "hero_title": "Le Poké Station - Franchise de Bols Poké Hawaïens",
                "hero_alt": "Le Poké Station",
                "hero_description": "Savourez des bols poké hawaéens authentiques préparés avec finesse et minutie. Chaque bol propose des ingrédients uniques et harmonieux soigneusement élaborés par nos chefs d'expérience.",
                "about": {
                    "tagline": "ALOHA ! Découvrez le goût d'Hawaï",
                    "description": "Chez <b>Le Poké Station<\/b>, les bols poké sont préparés avec finesse et diligence. Chaque item du menu contient des ingrédients uniques et harmonieux qui ont été soigneusement créés par des chefs expérimentés. Que ce soit pour manger sainement ou pour un événement spécial, vous serez satisfait de votre expérience !",
                    "image_alt": "Préparation de bol poké"
                },
                "franchise_investment": {
                    "why_choose_title": "Pourquoi choisir Le Poké Station ?",
                    "benefits": {
                        "successful_locations": {
                            "title": "{count} emplacements établis",
                            "description": "Historique prouvé à travers le Québec et Ottawa"
                        },
                        "multi_platform": {
                            "title": "Livraison multi-plateformes",
                            "description": "Disponible sur toutes les principales plateformes de livraison"
                        },
                        "flexible_locations": {
                            "title": "Emplacements flexibles",
                            "description": "Loyer abordable et exigences d'espace flexibles"
                        },
                        "delivery_support": {
                            "title": "Support de l'équipe de livraison",
                            "description": "Support complet pour les opérations de livraison"
                        }
                    }
                },
                "delivery_partners": {
                    "title": "Commande en ligne & livraison",
                    "subtitle": "Disponible sur toutes les grandes plateformes de livraison pour vous simplifier la vie",
                    "footer_title": "Réseau de livraison complet",
                    "footer_description": "Le Poké Station travaille avec toutes les principales plateformes de livraison afin d'offrir un maximum de commodité et de portée à notre clientèle.",
                    "footer_extra_text": "En plus d'une équipe dédiée de livreurs pour assurer un service impeccable !"
                },
                "locations": {
                    "title": "Nos emplacements",
                    "subtitle": "{count} succursales au Québec et à Ottawa",
                    "cta_title": "Rejoignez notre réseau en pleine croissance",
                    "cta_description": "Faites partie du plus grand réseau de franchises de poké au Québec, reconnu pour son succès dans plusieurs marchés.",
                    "cta_button": "Commencez votre parcours de franchisé"
                },
                "menu": {
                    "title": "Nos bols classiques",
                    "subtitle": "Des bols poké frais, savoureux et personnalisables avec des ingrédients de première qualité",
                    "items": {
                        "sama": {
                            "title": "Sama",
                            "description": "Saumon et thon épicés, saumon et thon marinés",
                            "alt": "Bol Sama"
                        },
                        "katsu_chicken": {
                            "title": "Poulet katsu",
                            "description": "Poulet katsu croustillant avec légumes frais",
                            "alt": "Bol poulet katsu"
                        },
                        "veggie": {
                            "title": "Bol végé",
                            "description": "Patate douce, inari et edamame",
                            "alt": "Bol végé"
                        },
                        "tuna": {
                            "title": "Thon",
                            "description": "Thon épicé et thon mariné",
                            "alt": "Bol thon"
                        }
                    }
                },
                "cta": {
                    "title": "Prêt à commencer votre franchise Le Poké Station ?",
                    "description": "Rejoignez le plus grand réseau de franchise poké au Québec et apportez ALOHA à votre communauté avec des bols hawaïens frais et sains !",
                    "image_alt": "Le Poké Station"
                },
                "support_service": {
                    "title": "Notre soutien et service",
                    "subtitle": "Support complet à chaque étape du parcours",
                    "image_alt": "Soutien Le Poke Station",
                    "steps": {
                        "site_selection": {
                            "title": "Sélection de site",
                            "description": "Notre équipe immobilière expérimentée vous assistera dans la sélection de votre site et la négociation de votre bail."
                        },
                        "financial_support": {
                            "title": "Soutien financier",
                            "description": "Nous aidons avec les exigences des institutions financières et les demandes de prêt par le biais de nos partenariats avec les coopératives de crédit."
                        },
                        "training_program": {
                            "title": "Programme de formation",
                            "description": "Formation théorique et pratique complète avec support sur site pour vous et votre personnel."
                        },
                        "operational_support": {
                            "title": "Soutien opérationnel",
                            "description": "L'équipe d'opération dédiée assure le respect des processus et des hauts standards avec des manuels détaillés."
                        },
                        "marketing_community": {
                            "title": "Communauté marketing",
                            "description": "Programmes de marketing local avec département graphique interne et support de communauté en ligne engagée."
                        }
                    }
                }
            },
            "kalemart24": {
                "title": "KaleMart24 - Plus qu'un simple dépanneur",
                "tagline": "Plus qu'un simple dépanneur",
                "hero": {
                    "title": "Faîtes partie d'un réseau en pleine expansion",
                    "description": "KaleMart24 se développe à travers l'Amérique du Nord et recherche des franchisés qui souhaitent faire partie d'une opportunité exclusive pour se joindre à l'une des tendances à la croissance des plus rapides au monde.",
                    "alt": "Opportunité de franchise KaleMart24"
                },
                "about": {
                    "title": "Une offre incomparable.",
                    "description": "KaleMart24 redéfini le Dépanneur en offrant un sanctuaire de choix soucieux de votre santé qui vous permettent de prendre des décisions réfléchies, sans effort. KaleMart24 rend les produits naturels, non seulement accessibles, mais également intégrés à votre routine quotidienne. KaleMart24 est une chaîne de dépanneurs santé qui rend l'achat d'aliments naturels et biologiques incroyablement accessible dans l'ambiance conviviale d'un petit marché combiné à l'élégance moderne d'un magasin haut de gamme.",
                    "features": "En offrant des marques et des produits de qualité, KaleMart24 comprend toutes les sections habituelles d'un dépanneur, ainsi qu'un comptoir libre-service de café et de matcha, une petite section de soins personnels et une petite section de produits d'animaux de compagnie."
                },
                "why_franchise": {
                    "title": "Pourquoi",
                    "subtitle": "10 raisons d'ouvrir un KaleMart24 aujourd'hui :",
                    "reasons": {
                        "turn_key": "Solution CLÉ-EN-MAIN",
                        "recession_resistant": "Modèle résistant à la récession",
                        "affordable_investment": "Investissement abordable",
                        "full_service_design": "Équipe de conception",
                        "real_estate_support": "Soutien en immobilier et construction",
                        "branding_marketing": "Image de marque unique",
                        "supply_chain": "Une chaîne d'approvisionnement et de distribution solide",
                        "training": "Formation continue",
                        "easy_to_operate": "Facile à opérer",
                        "multi_unit": "Opportunité de multi-unités"
                    }
                },
                "location_standards": {
                    "title": "Normes de localisation",
                    "size": {
                        "title": "Taille de l'emplacement",
                        "minimum": "Minimum de 750 pi²",
                        "maximum": "Maximum de 2 000 pi²"
                    },
                    "locations": {
                        "title": "Emplacements",
                        "description": "Les lieux proches de la maison ou sur le chemin du travail sont primordiaux pour profiter de la catégorie du prêt-à-manger à emporter."
                    },
                    "preferred": {
                        "title": "Emplacements préférés",
                        "types": "Stations de métro; Universités; Centre-ville; Centres commerciaux; Aéroports"
                    }
                },
                "process": {
                    "title": "Processus simple",
                    "steps": {
                        "submit_request": {
                            "name": "Soumettre la demande",
                            "description": "Vous soumettez votre demande de franchise en ligne."
                        },
                        "follow_up": {
                            "name": "Suivi de la demande",
                            "description": "Notre équipe vous contacte et vous envoie une demande de franchise officielle à remplir."
                        },
                        "agreement": {
                            "name": "Signer l’entente",
                            "description": "Si votre candidature est acceptée, nous signons le contrat de franchise et vous devenez un partenaire franchisé KaleMart24."
                        },
                        "secure_build": {
                            "name": "Trouver un local & Construire",
                            "description": "Nous vous aidons à trouver un emplacement et à démarrer la construction."
                        },
                        "train_open": {
                            "name": "Formation & Ouverture",
                            "description": "Vous complétez notre formation de 2 semaines et vous ouvrez les portes de votre propre KaleMart24 !"
                        }
                    }
                },
                "locations": {
                    "title": "Trouvez un KaleMart24 près de chez vous",
                    "description": "Vous ne voyez pas encore de KaleMart24 près de chez vous ? Restez à l'affût : il se pourrait qu'un magasin KaleMart24 apparaisse dans votre quartier plus tôt que vous ne le pensez !"
                },
                "investment": {
                    "title": "Exigences de franchise",
                    "description": "KaleMart24 se développe à travers le Québec et recherche des franchisés qui souhaitent faire partie d'une opportunité exclusive pour se joindre à l'une des tendances à la croissance des plus rapides au monde."
                },
                "cta": {
                    "title": "Prêt à commencer votre franchise KaleMart24?",
                    "description": "Rejoignez la révolution du bien-être dans le commerce de proximité. Faites partie de la tendance de magasins de commodité sains à la croissance la plus rapide.",
                    "image_alt": "KaleMart24"
                }
            },
            "ganadara": {
                "hero_title": "Ganadara - Cuisine Fusion Coréenne",
                "hero_description": "Ganadara sert une cuisine fusion coréenne et étend son expérience au-delà de la restauration en salle pour inclure des options de plats à emporter et de livraison uniquement. Le nouveau concept est que les meilleurs repas se dégustent dans le confort de votre foyer.",
                "hero_alt": "Ganadara",
                "locations": {
                    "title": "Nos franchises",
                    "subtitle_template": "{count} magasins et en croissance à travers le Québec",
                    "cta_title": "Rejoignez notre réseau",
                    "cta_description": "Devenez membre de notre famille grandissante de partenaires franchisés prospères.",
                    "cta_button": "Commencez votre aventure"
                },
                "delivery_partners": {
                    "title": "Commande en ligne et livraison",
                    "subtitle": "Ganadara s'associe à tous les principaux services de livraison pour offrir des options de commande pratiques",
                    "footer_title": "Stratégie multi-plateforme",
                    "footer_description": "Avec la popularité croissante du service de livraison, nous travaillons en étroite collaboration avec tous les principaux partenaires de plateformes de livraison pour assurer un flux de revenus sain et augmenter la visibilité de la marque."
                },
                "about": {
                    "tagline": "Tradition coréenne modernisée",
                    "description_1": "Chez <b>Ganadara<\/b>, nous servons une cuisine fusion coréenne, et le restaurant étend son expérience au-delà de la restauration en salle pour ajouter des emplacements de plats à emporter et de livraison uniquement, le nouveau concept étant que les meilleurs repas sont généralement dégustés dans le confort de votre propre maison.",
                    "description_2": "Que nos clients soient en pause déjeuner, pour dîner ou pour une bouchée rapide sur le pouce, chacun trouvera quelque chose à son goût et pour chaque occasion. La diversité de notre menu nous permet de répondre à tous les types de styles de vie et de préférences alimentaires.",
                    "image_alt": "À propos de Ganadara"
                },
                "menu": {
                    "title": "Notre menu",
                    "subtitle": "Des plats coréens traditionnels aux spécialités modernes, nous répondons à tous les types de styles de vie et de préférences alimentaires",
                    "highlights": {
                        "supreme_poutine": {
                            "title": "Poutine tteokbokki suprême",
                            "description": "Poutine tteokbokki aux moules, au boeuf et au poulet"
                        },
                        "grilled_squid": {
                            "title": "Calmar grillé",
                            "description": "Calmar grillé à la flamme, parfait à partager"
                        },
                        "soondubu": {
                            "title": "Soondubu",
                            "description": "Ragoût coréen bien chaud et réconfortant"
                        },
                        "tteokkochi": {
                            "title": "Tteokkochi",
                            "description": "Bouchées de tteok fondantes nappées d'une sauce sucrée et épicée"
                        },
                        "dolsot": {
                            "title": "Dolsot bibimbap",
                            "description": "Bibimbap servi dans un bol de pierre brûlant"
                        },
                        "dak_balls": {
                            "title": "Boulettes de dak",
                            "description": "Poulet frit à la façon Ganadara"
                        },
                        "mandu": {
                            "title": "Mandu",
                            "description": "Dumplings coréens maison"
                        }
                    }
                },
                "support_service": {
                    "title": "Notre soutien et service",
                    "subtitle": "Un soutien complet à la franchise, du début au succès",
                    "image_alt": "Soutien Ganadara",
                    "steps": {
                        "site_selection": {
                            "title": "Sélection du site",
                            "description": "Notre équipe expérimentée en immobilier\/développement vous aidera à choisir votre site et à négocier votre bail."
                        },
                        "financial_support": {
                            "title": "Soutien financier",
                            "description": "Nous travaillerons avec vous pour nous assurer que votre institution financière dispose des informations nécessaires pour compléter votre demande de prêt. Ganadara dispose d'un programme national de franchise avec plusieurs grandes coopératives de crédit."
                        },
                        "training_program": {
                            "title": "Programme de formation",
                            "description": "Nous offrons aux franchisés une formation théorique et pratique. Nous soutenons le restaurant avec une équipe de formateurs sur place pour vous aider, vous et votre personnel."
                        },
                        "operational_support": {
                            "title": "Soutien opérationnel",
                            "description": "Notre équipe d'exploitation dédiée et expérimentée travaille avec le franchisé pour assurer le respect des processus et des normes élevées de Ganadara. Des manuels couvrant tous les processus d'exploitation et de gestion seront mis à votre disposition pour référence."
                        },
                        "marketing_community": {
                            "title": "Communauté très engagée",
                            "description": "Ganadara est soutenu par une équipe marketing qui propose des programmes de marketing locaux adaptés aux communautés dans lesquelles ils sont situés. Avec un département graphique interne et des spécialistes de l'audiovisuel travaillant à temps plein, les moyens ensoleillés de Ganadara vont loin. De plus, la communauté en ligne très engagée montre à quel point la marque Ganadara est proche du cœur de ses clients."
                        }
                    }
                },
                "cta": {
                    "title": "Prêt à démarrer votre franchise Ganadara ?",
                    "description": "Rejoignez-nous pour apporter une authentique cuisine fusion coréenne aux communautés du monde entier.",
                    "image_alt": "Franchise Ganadara"
                }
            },
            "turnberry": {
                "title": "Turnberry - Bols d'Acai Premium",
                "tagline": "La maison du meilleur acai",
                "hero": {
                    "title": "Ouvrez Votre TurnBerry.",
                    "description": "Créez une marque adorée et apportez des bols d'açaï sains et délicieux à votre communauté.",
                    "alt": "Opportunité de franchise TurnBerry Acai"
                },
                "about": {
                    "title": "Notre Mission",
                    "header_1": "Derrière le tout meilleur açaï",
                    "description": "Pour avoir un impact significatif sur la communauté : un bol d'açaï à la fois, en proposant des produits de haute qualité et en établissant des relations humaines authentiques sur chaque marché où nous sommes présents.",
                    "header_2": "Intention stratégique",
                    "intents": {
                        "intent_1": "Créer une marque lifestyle axée sur le bien-être et la joie",
                        "intent_2": "Devenir la marque d'açaï haut de gamme leader au Canada et au-delà",
                        "intent_3": "Influencer la culture grâce à la communauté, à la présence numérique et à l'excellence de la franchise"
                    }
                },
                "location_standards": {
                    "title": "Normes de localisation",
                    "size": {
                        "title": "Taille de l'emplacement",
                        "minimum": "Minimum de 300 pi²",
                        "maximum": "Maximum de 1 000 pi²"
                    },
                    "locations": {
                        "title": "Emplacements",
                        "description": "Les lieux proches de la maison ou sur le chemin du travail sont primordiaux pour profiter de la catégorie du prêt-à-manger à emporter."
                    },
                    "header": "Choisissez Votre Format Idéal",
                    "description": "Nous offrons trois formats de franchise flexibles conçus pour correspondre à votre ambition et à votre marché.",
                    "formats": {
                        "kiosk": {
                            "title": "Kiosque \/ Foire Alimentaire",
                            "description": "Parfait pour les centres commerciaux à fort trafic et les services rapides. Des opérations simplifiées pour un flux client maximal."
                        },
                        "flagship": {
                            "title": "Boutique Phare",
                            "description": "L'expérience TurnBerry ultime. Idéal pour les quartiers branchés et les centres communautaires avec places assises."
                        },
                        "standalone": {
                            "title": "Succursale Indépendante",
                            "description": "Devenez un incontournable du quartier. Parfait pour une domination du marché local avec stationnement dédié."
                        }
                    }
                },
                "process": {
                    "title": "Votre Entreprise Clé en Main",
                    "description": "Nous fournissons la marque, les systèmes et le soutien. Vous apportez la passion et l'expertise locale. Ensemble, nous bâtissons quelque chose d'incroyable.",
                    "steps": {
                        "rd_menu": {
                            "name": "R&D & Menu",
                            "description": "Recettes éprouvées et innovation continue des produits."
                        },
                        "branding_marketing": {
                            "name": "Marque & Marketing",
                            "description": "Guides de marque complets et boîtes à outils marketing."
                        },
                        "training_support": {
                            "name": "Formation & Soutien",
                            "description": "Formation complète et soutien opérationnel continu."
                        },
                        "supply_chain": {
                            "name": "Chaîne d'Approvisionnement",
                            "description": "Fournisseurs fiables et gestion des stocks simplifiée."
                        },
                        "tech_stack": {
                            "name": "Technologie",
                            "description": "Systèmes de point de vente, applications de commande et analyses."
                        },
                        "operations_manual": {
                            "name": "Manuel d'Opérations",
                            "description": "Processus détaillés pour des opérations quotidiennes efficaces."
                        }
                    }
                },
                "locations": {
                    "title": "Nos Emplacements",
                    "description": "Trouvez votre TurnBerry le plus proche et entrez dans un monde d'açaí, d'éclairage doux et de l'ambiance dont vous ne saviez pas avoir besoin."
                },
                "cta": {
                    "title": "Prêt à apporter le meilleur à votre ville?",
                    "description": "Rejoignez la marque d'açaï qui connaît la plus forte croissance au Canada et construisez quelque chose qui a du significatif.",
                    "image_alt": "TurnBerry Acai"
                }
            }
        },
        "components": {
            "store_locator": {
                "search": {
                    "placeholder": "Rechercher par nom de magasin, adresse ou ville...",
                    "location_button_loading": "Localisation en cours...",
                    "location_button": "Utiliser ma position"
                },
                "filters": {
                    "brand_placeholder": "Sélectionner une marque",
                    "brand_all": "Toutes les marques",
                    "province_placeholder": "Sélectionner une province",
                    "province_all": "Toutes les provinces",
                    "clear_filters": "Effacer les filtres",
                    "clear_filters_title": "Effacer tous les filtres"
                },
                "results": {
                    "showing": "Affichage de {filtered} sur {total} magasins",
                    "sorted_by_distance": "Trié par distance"
                },
                "empty_state": {
                    "no_stores_title": "Aucun magasin trouvé",
                    "no_stores_description": "Essayez d'ajuster votre recherche ou vos filtres"
                }
            }
        },
        "crm": {
            "leads": {
                "actions": {
                    "request_information": "Demander des renseignements",
                    "save_changes": "Enregistrer les modifications",
                    "submit_lead": "Soumettre le prospect"
                },
                "admin": {
                    "create": {
                        "modal_success": "Merci pour la soumission. Les renseignements ont été consignés dans le CRM.",
                        "page_subtitle": "Collectez les renseignements des franchisés potentiels et transmettez-les directement au CRM.",
                        "page_title": "Génération de prospects CRM"
                    },
                    "edit": {
                        "back_to_details": "Retour aux détails du prospect",
                        "description": "Mettez à jour les renseignements saisis pour ce prospect.",
                        "heading": "Modifier le prospect",
                        "notes_placeholder": "Ajoutez toute note ou mesure de suivi pertinente",
                        "page_title": "Modifier le prospect no {id}",
                        "qualified_label": "Le prospect est qualifié"
                    },
                    "index": {
                        "description": "Suivez tous les prospects soumis et surveillez leur suivi.",
                        "empty": "Aucun prospect trouvé pour le moment.",
                        "headers": {
                            "deposit": "Dépôt",
                            "email": "Courriel",
                            "name": "Nom",
                            "phone": "Téléphone",
                            "qualified": "Qualifié",
                            "source": "Source",
                            "status": "Statut",
                            "submitted": "Soumis"
                        },
                        "new_lead": "Nouveau prospect",
                        "title": "Prospects CRM"
                    },
                    "show": {
                        "interested_brands": "Marques d'intérêt",
                        "lead_management": "Gestion du prospect",
                        "notes_placeholder": "Ajoutez les détails de suivi ici",
                        "page_title": "Prospect no {id}",
                        "submitted_at": "Soumis le {date}"
                    }
                },
                "fields": {
                    "area_of_interest": {
                        "label": "Quelle région vous intéresse?",
                        "placeholder": "Ville, province ou région"
                    },
                    "badge_number": {
                        "label": "Numéro de badge (facultatif)",
                        "placeholder": "Saisissez le numéro de badge s'il y a lieu"
                    },
                    "current_occupation": {
                        "label": "Quelle est votre occupation actuelle?"
                    },
                    "deposit": {
                        "label": "Montant du dépôt",
                        "placeholder": "0.00"
                    },
                    "email": {
                        "label": "Courriel",
                        "placeholder": "nom{'@'}example.com"
                    },
                    "full_name": {
                        "label": "Nom complet"
                    },
                    "intended_role": {
                        "label": "Quel rôle envisagez-vous d'occuper?",
                        "placeholder": "Propriétaire-exploitant, investisseur, partenaire, etc."
                    },
                    "interested_brands": {
                        "help": "Sélectionnez une ou plusieurs marques.",
                        "label": "Quelle marque vous intéresse?"
                    },
                    "launch_timing": {
                        "label": "Quand souhaitez-vous lancer votre entreprise?",
                        "placeholder": "Sélectionnez un délai"
                    },
                    "liquid_capital": {
                        "label": "Quel capital liquide pouvez-vous investir?",
                        "placeholder": "Sélectionnez une tranche montante"
                    },
                    "notes": {
                        "internal_placeholder": "Ajoutez des notes internes ou des actions de suivi",
                        "label": "Notes"
                    },
                    "phone_number": {
                        "label": "Numéro de téléphone",
                        "placeholder": "+1 (514) 555-1234"
                    },
                    "qualified": {
                        "label": "Qualifié"
                    },
                    "source": {
                        "label": "Source de la demande",
                        "placeholder": "Sélectionnez une source"
                    },
                    "status": {
                        "label": "Statut"
                    }
                },
                "messages": {
                    "created": "Votre soumission a été réussie.",
                    "updated": "Votre soumission a été mise à jour avec succès."
                },
                "options": {
                    "launch_timing": {
                        "one_year_or_more": "1 an ou plus",
                        "six_to_twelve_months": "De 6 à 12 mois",
                        "three_to_six_months": "De 3 à 6 mois",
                        "within_3_months": "D'ici 3 mois"
                    },
                    "liquid_capital": {
                        "100k-150k": "100 000 $ à 150 000 $",
                        "150k-200k": "150 000 $ à 200 000 $",
                        "200k-300k": "200 000 $ à 300 000 $",
                        "300k-400k": "300 000 $ à 400 000 $",
                        "400k-500k": "400 000 $ à 500 000 $",
                        "50k-100k": "50 000 $ à 100 000 $",
                        "500k+": "500 000 $ et plus"
                    },
                    "sources": {
                        "franchise_expo": "Expo Franchise",
                        "meta": "Meta (Facebook\/Instagram)",
                        "tiktok": "TikTok",
                        "web_inquiry": "Demande en ligne",
                        "youtube": "YouTube"
                    },
                    "status": {
                        "closed": "Fermé",
                        "contacted": "Contacté",
                        "new": "Nouveau",
                        "pending_deposit": "Dépôt en attente"
                    }
                },
                "public": {
                    "modal_success": "Merci! Notre équipe vous contactera sous peu.",
                    "page_subtitle": "Remplissez ce formulaire pour joindre notre équipe de franchisage.",
                    "page_title": "Expo Franchise"
                },
                "shared": {
                    "back_to_leads": "Retour aux prospects",
                    "modal": {
                        "default_message": "Merci pour la soumission. Les renseignements ont été consignés dans le CRM.",
                        "title": "Succès!",
                        "redirect_message": "Vous serez redirigé vers la liste des prospects dans 5 secondes ou cliquez sur le bouton ci-dessous pour y accéder maintenant.",
                        "redirect_now": "Aller aux prospects maintenant"
                    },
                    "no_notes_recorded": "Aucune note enregistrée pour le moment.",
                    "none_provided": "Aucune indiquée",
                    "unknown_value": "--"
                }
            }
        },
        "franchise": {
            "title": "Devenir notre partenaire",
            "information_request": "Demande d'informations",
            "manage_booking_title": "Gérer votre réservation",
            "information_request_description": "Veuillez répondre aux questions suivantes, qui nous aideront à déterminer si vous êtes un franchisé potentiel qualifié.",
            "form": {
                "referrer": "Référent",
                "name": "Nom",
                "date_of_birth": "Date de naissance",
                "phone_number": "Numéro de téléphone",
                "email": "Adresse courriel",
                "interested_brands": "Quelles sont les marques qui vous intéressent le plus ?",
                "investments": "Quelle somme avez-vous à investir ?",
                "project_details": "Votre projet",
                "financial_details": "Votre investissement",
                "select_option": "Sélectionnez une option",
                "qualification": {
                    "not_provided": "Non renseigné",
                    "needs_loan": {
                        "question": "Aurez-vous besoin d’un prêt ?",
                        "options": {
                            "yes": "Oui",
                            "no": "Non",
                            "not_sure": "Pas encore sûr"
                        }
                    },
                    "credit_score_range": {
                        "question": "Quelle est votre cote de crédit approximative ?",
                        "options": {
                            "below_600": "Moins de 600",
                            "600_659": "600–659",
                            "660_699": "660–699",
                            "700_749": "700–749",
                            "750_plus": "750+",
                            "unknown": "Je ne sais pas"
                        }
                    },
                    "residency_status": {
                        "question": "Êtes-vous citoyen canadien ou résident permanent ?",
                        "options": {
                            "canadian_citizen": "Citoyen canadien",
                            "permanent_resident": "Résident permanent",
                            "neither": "Ressortissant étranger",
                            "not_sure": "Pas encore sûr"
                        }
                    },
                    "relevant_experience": {
                        "question": "Avez-vous de l’expérience pertinente pour cette franchise ?",
                        "options": {
                            "yes": "Oui",
                            "no": "Non",
                            "not_sure": "Pas encore sûr"
                        }
                    },
                    "has_partners": {
                        "question": "Des partenaires se joindront-ils à vous pour ce projet ?",
                        "options": {
                            "yes": "Oui",
                            "no": "Non",
                            "not_sure": "Pas encore sûr"
                        }
                    }
                },
                "area_of_interest": "Dans quelle région souhaitez-vous ouvrir une franchise ?",
                "launch_timing": {
                    "question": "Quand souhaitez-vous lancer votre franchise ?",
                    "within_3_months": "Dans les 3 prochains mois",
                    "3_to_6_months": "Dans 3 à 6 mois",
                    "6_to_12_months": "Dans 6 à 12 mois",
                    "1_year_or_more": "Dans 1 an ou plus tard"
                },
                "who_is_the_operator": {
                    "question": "Exploiterez-vous vous-même l’entreprise ?",
                    "myself": "Moi-même",
                    "someone_else": "Quelqu’un d’autre"
                },
                "address": "Adresse",
                "city": "Ville",
                "province": "Province",
                "postal_code": "Code Postal",
                "education": "Formation académique",
                "work_experience": "Expérience professionnelle",
                "current_income": "Revenu d’emploi actuel",
                "other_income": "Autres revenus",
                "specify_other_income": "Si autres revenus, spécifiez",
                "bank": "Institution(s) financière(s) où vous faites affaires",
                "branch": "Succursale",
                "criminal_record": "Avez-vous déjà été reconnu coupable d’un crime ?",
                "franchise_will_be_the_only_source_of_revenue": "Votre franchise représenterait-elle votre seule source de revenus ?",
                "total_assets": "Total de vos avoirs",
                "total_debts": "Total de vos dettes",
                "minus": "Moins",
                "net_worth": "Valeur nette",
                "amount_available_for_investment": "Somme disponible pour investir",
                "financing_source": "Source de financement pour votre franchise",
                "credit_rating": "Cote de crédit",
                "opening_date": "Si votre demande est acceptée, quand seriez-vous prêt à faire l’acquisition de votre franchise ?",
                "location": "Endroit où vous aimeriez exploiter votre franchise",
                "operator": "Comptez-vous opérer votre franchise vous-même ?",
                "if_not_operator": "Si non, à qui confierez-vous la gestion quotidienne de votre franchise ?",
                "short_training": "Serez-vous disponible 2 semaines à temps pleins avant l’ouverture ou la prise de possession de votre restaurant pour vous faire former dans un restaurant existant même si vous souhaitez confier vos opérations quotidiennes à une autre personne",
                "long_training": "Serez-vous disponible lors des 3 premiers mois pour l’ouverture du restaurant pour vous faire former, même si vous souhaitez confier vos opérations quotidiennes à une autre personne",
                "other_party": "Indiquez, dans l’espace prévu les noms de toute autre personne devant participer à l’exploitation de votre franchise. S’il advient que l’une ou l’autre de ces personnes est tenue de signer la Convention de franchise, faites-lui compléter une demande d’information.",
                "yes": "Oui",
                "no": "Non",
                "newsletter": "J'accepte de recevoir des communications électroniques de Franchiseur par e-mail et\/ou par SMS.",
                "terms": "J'accepte que les informations fournies soient utilisées à des fins de développement commercial. Un représentant peut vous contacter par téléphone et\/ou par courrier électronique pour discuter d'opportunités pertinentes. Pour plus de détails, veuillez consulter notre politique de confidentialité.",
                "schedule": {
                    "prompt": "Souhaitez-vous planifier un appel avec nous ?",
                    "description": "Choisissez une journée disponible et une période préférée.",
                    "date_label": "Date de l'appel",
                    "period_label": "Période préférée",
                    "current_booking_title": "Réservation actuelle",
                    "current_booking_description": "Voici votre appel planifié. Vous pouvez choisir une autre date ou période au besoin.",
                    "current_booking_missing": "Aucun détail de réservation disponible",
                    "reschedule_button": "Replanifier",
                    "update_booking": "Mettre à jour la réservation",
                    "select_date": "Sélectionner une date",
                    "select_period": "Sélectionner une période",
                    "loading": "Chargement des périodes disponibles...",
                    "load_error": "Nous n'avons pas pu charger les périodes disponibles pour cette date. Veuillez choisir une autre date ou réessayer.",
                    "available_spots": "{count} places disponibles",
                    "full": "Complet",
                    "unavailable": "Non disponible",
                    "unavailable_error": "Cette période d'appel n'est plus disponible. Veuillez choisir un autre moment.",
                    "lead_time_unavailable": "Preavis de {hours} heures requis",
                    "lead_time_error": "Veuillez choisir une periode d'appel dans au moins {hours} heures.",
                    "email_requested": "Appel demandé",
                    "periods": {
                        "morning": "Matin",
                        "afternoon": "Après-midi",
                        "evening": "Soir"
                    }
                },
                "submit": "Envoyer la demande"
            },
            "success": "Votre demande a été envoyée !",
            "success_message": "Nous avons reçu votre demande et communiquerons avec vous bientôt.",
            "success_scheduled_message": "Votre appel est confirmé. Nous avons hâte de vous parler le :",
            "return_home": "Retour à l'accueil",
            "call_confirmation": {
                "email": {
                    "subject": "Votre appel Franchiseur est planifié",
                    "greeting": "Bonjour {name},",
                    "intro": "Votre appel avec Franchiseur a été planifié. Les détails sont ci-dessous.",
                    "manage_booking_button": "Gérer votre réservation",
                    "signoff": "Merci,"
                },
                "sms": {
                    "confirmation": "Franchiseur : votre appel est planifié pour le {date} ({period}). Gérez votre réservation ici : {url}",
                    "reminder": "Rappel Franchiseur : votre appel est demain, le {date} ({period}). Gérez votre réservation ici : {url}"
                }
            },
            "admin_call_availability": {
                "title": "Disponibilités d'appel",
                "description": "Gérez la capacité hebdomadaire par défaut et les exceptions pour des dates précises.",
                "weekly_defaults": "Disponibilités hebdomadaires",
                "date_overrides": "Exceptions par date",
                "enabled": "Activé",
                "capacity": "Capacité",
                "save_defaults": "Enregistrer",
                "add_override": "Ajouter une exception",
                "date": "Date",
                "period": "Période",
                "no_overrides": "Aucune exception de date n'a été créée.",
                "remove_override": "Supprimer",
                "messages": {
                    "updated": "Les disponibilités d'appel ont été mises à jour.",
                    "override_saved": "L'exception de disponibilité a été enregistrée.",
                    "override_deleted": "L'exception de disponibilité a été supprimée."
                }
            },
            "admin_inquiries": {
                "index": {
                    "title": "Demandes",
                    "description": "Consultez les demandes de franchise.",
                    "headers": {
                        "name": "Nom",
                        "email": "Courriel",
                        "phone": "Telephone",
                        "booking": "Reservation",
                        "submitted": "Soumise",
                        "actions": "Actions"
                    },
                    "empty": "Aucune demande n'a encore ete soumise."
                },
                "show": {
                    "page_title": "Demande #{id}",
                    "back_to_inquiries": "Retour aux demandes",
                    "submitted_at": "Soumise le {date}",
                    "contact_details": "Coordonnees",
                    "inquiry_details": "Details de la demande",
                    "booking_details": "Details de la reservation",
                    "language": "Langue",
                    "reminder_sent": "Rappel envoye",
                    "none_provided": "Aucun renseignement",
                    "save_booking": "Enregistrer la reservation"
                },
                "booking": {
                    "status": "Statut de la reservation",
                    "not_requested": "Aucun appel demande",
                    "requested": "Appel demande",
                    "scheduled_short": "{date}, {period}"
                },
                "messages": {
                    "booking_updated": "Les details de la reservation ont ete mis a jour.",
                    "booking_cleared": "Les details de la reservation ont ete effaces."
                }
            }
        },
        "franchise_show": {
            "meta_title": "Salon de la franchise — Vous êtes invités",
            "event": "Salon de la franchise",
            "headline": "Vous êtes invités.",
            "booths": "Retrouvez-nous aux kiosques",
            "description": "Venez rencontrer l’équipe Franchiseur, découvrir nos marques et explorer votre prochaine occasion d’affaires.",
            "tickets": "Obtenez vos billets gratuits",
            "brands_title": "Découvrez nos marques.",
            "brands_description": "Neuf marques. Un monde de possibilités. Trouvez celle qui vous ressemble.",
            "closing_title": "Rencontrons-nous au salon.",
            "closing_description": "Votre prochain chapitre pourrait commencer par une conversation. On vous attend aux kiosques 501–502."
        },
        "franchiseur": {
            "intro": {
                "subtitle": "Saisissez l'Opportunité d'une Vie",
                "title": "Favoriser la Réussite avec des Systèmes de Franchise Éprouvés",
                "description": "Chez Franchiseur, nous offrons une voie vers le succès grâce à nos méthodologies éprouvées, à un mentorat de premier ordre et à une formation complète. Nos modèles d'affaires florissants avec un historique de succès offrent des opportunités pour les entrepreneurs et les passionnés d'affaires de construire leur propre histoire et leur héritage avec nos marques éprouvées et vérifiées.<br \/><br \/>\nCréez et développez votre héritage, c'est le moment pour vous de faire la différence. Commencez votre aventure entrepreneuriale avec nous.",
                "cta": "Discutons ensemble"
            },
            "portfolio": {
                "title": "Notre Portefeuille de Franchises Performantes",
                "description": "Avec un vaste réseau de franchises prospères réparties sur plusieurs endroits et territoires clés, le succès de Franchiseur démontre la puissance d'un modèle éprouvé et axé sur la passion dans divers marchés et secteurs d'activité.<br \/><br \/>\nPrêt à rejoindre une marque de franchise performante et construite pour le succès ?",
                "cta": "Je suis intéressé"
            },
            "steps": {
                "title": "Devenir Propriétaire d'une Franchise",
                "step01": {
                    "title": "Candidature et introduction",
                    "description": "Commencez votre parcours en remplissant un rapide formulaire de candidature en ligne. Nous examinerons votre expérience et vos antécédents pour nous assurer qu'ils correspondent bien à la franchise souhaitée."
                },
                "step02": {
                    "title": "Rencontre et évaluation",
                    "description": "Nous prenons contact avec vous, discutons de vos objectifs, de vos motivations et de votre vision, et passons en revue vos questions avant de procéder à une évaluation financière."
                },
                "step03": {
                    "title": "Approbation, découverte et intégration",
                    "description": "Après avoir reçu le feu vert, vous signerez le contrat de franchise pour nous rejoindre. Notre équipe vous proposera une formation en cours d'emploi et des programmes d'intégration pour vous permettre de réussir."
                }
            },
            "interviews": {
                "title": "Derrière l'Empire",
                "description": "Découvrez des entrevues exclusives avec Jim Cam où il partage son parcours depuis le démarrage jusqu'à la construction d'un empire de franchises. Découvrez des perspectives directes sur les stratégies d'affaires en restauration, la gestion de franchises et les histoires de réussite entrepreneuriale."
            },
            "behind_the_business": {
                "title": "Derrière l'entreprise",
                "description": "Découvrez des histoires vécues et des conseils d’experts pour maîtriser le modèle de franchise avec Jim Cam, offrant un regard clair et honnête sur ce qu’il faut réellement pour bâtir, développer et gérer une franchise prospère."
            }
        },
        "legal": {
            "privacy_policy": "Politique de confidentialité",
            "terms_of_service": "Conditions d'utilisation",
            "privacy": "Confidentialité",
            "terms": "Conditions d'utilisation"
        },
        "location": {
            "add_exception": "Ajouter une exception",
            "add_time_slot": "Ajouter une plage horaire",
            "business_hours": "Heures d'ouverture",
            "closed_indefinitely": "Fermé indéfiniment",
            "closed_no_specified_time": "Si aucun horaire n'est précisé, l'établissement est considéré comme fermé ce jour-là.",
            "closed": "Fermé",
            "closing_soon": "Bientôt fermé",
            "exceptions_description": "Dates ou périodes spécifiques avec des horaires modifiés, différents du planning habituel (ex. : jours fériés, fermetures exceptionnelles, ou horaires étendus).",
            "exceptions": "Exceptions",
            "find_location": "Trouver un emplacement",
            "find_us": "Nous trouver",
            "get_directions": "Obtenir l'itinéraire",
            "location_search": "Recherche par adresse, code postal ou ville",
            "open_at": "Ouvert {datetime}",
            "open_until": "Ouvert jusqu'à {datetime}",
            "open": "Ouvert",
            "order_online": "Commande en ligne",
            "reason": "Raison",
            "regular_hours_description": "Horaires hebdomadaires fixes identiques chaque semaine.",
            "regular_hours": "Horaires réguliers",
            "store_info": "Info sur l'emplacement",
            "store": "Emplacement",
            "view_all_locations": "Voir tous les emplacements",
            "search": {
                "placeholder": "Rechercher par nom de magasin, adresse ou ville...",
                "location_button_loading": "Localisation en cours...",
                "location_button": "Utiliser ma position"
            },
            "filters": {
                "brand_placeholder": "Sélectionner une marque",
                "brand_all": "Toutes les marques",
                "province_placeholder": "Sélectionner une province",
                "province_all": "Toutes les provinces",
                "clear_filters": "Effacer les filtres",
                "clear_filters_title": "Effacer tous les filtres"
            },
            "results": {
                "showing": "Affichage de {filtered} sur {total} magasins",
                "sorted_by_distance": "Trié par distance"
            },
            "empty_state": {
                "no_stores_title": "Aucun magasin trouvé",
                "no_stores_description": "Essayez d'ajuster votre recherche ou vos filtres"
            }
        },
        "navigation": {
            "about": "À propos",
            "account_settings": "Paramètres du compte",
            "account": "Account",
            "behind_the_business": "Derrière l'entreprise",
            "book_a_all": "Lancez-vous",
            "brands": "Marques",
            "business_hours": "Heures d'ouverture",
            "business_opportunities": "Occasions d'affaires",
            "categories": "Catégories",
            "close_menu": "Fermer le menu",
            "close_sidebar": "Fermer la navigation latérale",
            "coupons": "Coupons",
            "customers": " Clients",
            "dashboard": "Tableau de bord ",
            "find_us": "Nous trouver",
            "franchise_expo": "Expo Franchise",
            "franchises": "Franchises",
            "franchising": "Franchisage",
            "interviews": "Entrevues",
            "jobs": "Emplois",
            "language_selector": "Selection de langue",
            "locations": "Emplacements",
            "menu": "Menu",
            "my_orders": "Mes commandes",
            "open_menu": "Ouvrir le menu",
            "open_sidenav": "Ouvrir la navigation latérale",
            "order_online": "Commande en ligne",
            "order": "Commander",
            "orders": "Commandes",
            "our_brands": "Nos Marques",
            "overview": "Aperçu",
            "private_event": "Événement privé",
            "partnership": "Partenariat",
            "products": "Produits",
            "profile": "Profile",
            "promotions": "Promotions",
            "settings": "Paramètres",
            "training": "Formation"
        },
        "pagination": {
            "previous": "&laquo; Précédent",
            "next": "Suivant &raquo;"
        },
        "passwords": {
            "reset": "Votre mot de passe a été réinitialisé!",
            "sent": "Nous vous avons envoyé par email le lien de réinitialisation du mot de passe!",
            "throttled": "Veuillez patienter avant de réessayer.",
            "token": "Ce jeton de réinitialisation du mot de passe n'est pas valide.",
            "user": "Aucun utilisateur n'a été trouvé avec cette adresse email."
        },
        "payment": {
            "balance_owed": "Solde dû",
            "card_number": "Numéro de carte",
            "cash": "Comptant",
            "credit_card": "Carte de crédit",
            "credit_debit": "Crédit et Débit",
            "cvc": "Code de sécurité",
            "debit_card": "carte de débit",
            "expiration": "Date d'expiration",
            "gift_card": "carte-cadeau ",
            "name_on_card": "Nom sur la carte",
            "paid_by": "Payé par",
            "pay_at_restaurant": "Payer au restaurant",
            "payment_method": "Mode de paiement",
            "payment_summary": "Sommaire du paiement",
            "save_card": "Enregistrer le moyen de paiement pour une utilisation future",
            "ending": "Se terminant par {last4}",
            "expires": "Expire le {month} \/ {year}",
            "success": "Paiement traité avec succès !",
            "refund_success": "Remboursement traité avec succès !",
            "capture_success": "Paiement capturé avec succès !",
            "pending": "Le paiement est en cours de traitement. Veuillez vérifier plus tard.",
            "requires_action": "Vérification supplémentaire requise. Veuillez compléter l'authentification du paiement.",
            "generic_error": "Une erreur est survenue lors du traitement de votre paiement. Veuillez réessayer.",
            "card_declined": "Votre carte a été refusée. Veuillez essayer un autre moyen de paiement.",
            "expired_card": "Votre carte a expiré. Veuillez essayer un autre moyen de paiement.",
            "incorrect_cvc": "Le code CVC est incorrect. Veuillez vérifier les détails de votre carte."
        },
        "privateevent": {
            "meta_title": "Événement privé",
            "headline": "Votre chance de rencontrer le Franchiseur",
            "description": "Procurez-vous le t-shirt en édition limitée pendant notre lancement de 24 heures. Chaque t-shirt est votre billet pour un événement de réseautage privé avec Jim Cam, le Franchiseur.",
            "target_launch": "Lancement prévu : {date}",
            "fallback_launch": "Définissez SHOP_LAUNCH_AT dans votre .env pour synchroniser le moment exact.",
            "launch_live": {
                "title": "La boutique est maintenant ouverte pour 24 heures seulement.",
                "body": "Profitez du drop unique pendant qu'il est en ligne : quand la fenêtre se ferme, c'est terminé.",
                "cta": "Entrer dans la boutique"
            },
            "ended": {
                "title": "La vente de l'Événement Privé est terminée.",
                "body": "La fenêtre de 24 heures s’est close le {date}. Merci à tous ceux qui ont participé au drop.",
                "cta": "Voir les produits"
            },
            "ends_heading": "La vente se termine dans",
            "countdown": {
                "days": "Jours",
                "hours": "Heures",
                "minutes": "Minutes",
                "seconds": "Secondes"
            },
            "form": {
                "placeholder": "Entrez votre courriel pour les mises à jour du lancement",
                "button": "S’abonner",
                "success": "Merci ! Vous serez averti le jour du lancement."
            }
        },
        "validation": {
            "accepted": "Le champ {attribute} doit être accepté.",
            "accepted_if": "Le champ {attribute} doit être accepté quand {other} a la valeur {value}.",
            "active_url": "Le champ {attribute} n'est pas une URL valide.",
            "after": "Le champ {attribute} doit être une date postérieure au {date}.",
            "after_or_equal": "Le champ {attribute} doit être une date postérieure ou égale au {date}.",
            "alpha": "Le champ {attribute} doit contenir uniquement des lettres.",
            "alpha_dash": "Le champ {attribute} doit contenir uniquement des lettres, des chiffres et des tirets.",
            "alpha_num": "Le champ {attribute} doit contenir uniquement des chiffres et des lettres.",
            "array": "Le champ {attribute} doit être un tableau.",
            "before": "Le champ {attribute} doit être une date antérieure au {date}.",
            "before_or_equal": "Le champ {attribute} doit être une date antérieure ou égale au {date}.",
            "between": {
                "array": "Le tableau {attribute} doit contenir entre {min} et {max} éléments.",
                "file": "La taille du fichier de {attribute} doit être comprise entre {min} et {max} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être comprise entre {min} et {max}.",
                "string": "Le texte {attribute} doit contenir entre {min} et {max} caractères."
            },
            "boolean": "Le champ {attribute} doit être vrai ou faux.",
            "confirmed": "Le champ de confirmation {attribute} ne correspond pas.",
            "current_password": "Le mot de passe est incorrect.",
            "date": "Le champ {attribute} n'est pas une date valide.",
            "date_equals": "Le champ {attribute} doit être une date égale à {date}.",
            "date_format": "Le champ {attribute} ne correspond pas au format {format}.",
            "declined": "Le champ {attribute} doit être décliné.",
            "declined_if": "Le champ {attribute} doit être décliné quand {other} a la valeur {value}.",
            "different": "Les champs {attribute} et {other} doivent être différents.",
            "digits": "Le champ {attribute} doit contenir {digits} chiffres.",
            "digits_between": "Le champ {attribute} doit contenir entre {min} et {max} chiffres.",
            "dimensions": "La taille de l'image {attribute} n'est pas conforme.",
            "distinct": "Le champ {attribute} a une valeur en double.",
            "email": "Le champ {attribute} doit être une adresse e-mail valide.",
            "ends_with": "Le champ {attribute} doit se terminer par une des valeurs suivantes : {values}",
            "enum": "Le champ {attribute} sélectionné est invalide.",
            "exists": "Le champ {attribute} sélectionné est invalide.",
            "file": "Le champ {attribute} doit être un fichier.",
            "filled": "Le champ {attribute} doit avoir une valeur.",
            "gt": {
                "array": "Le tableau {attribute} doit contenir plus de {value} éléments.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {value} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être supérieure à {value}.",
                "string": "Le texte {attribute} doit contenir plus de {value} caractères."
            },
            "gte": {
                "array": "Le tableau {attribute} doit contenir au moins {value} éléments.",
                "file": "La taille du fichier de {attribute} doit être supérieure ou égale à {value} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {value}.",
                "string": "Le texte {attribute} doit contenir au moins {value} caractères."
            },
            "image": "Le champ {attribute} doit être une image.",
            "in": "Le champ {attribute} est invalide.",
            "in_array": "Le champ {attribute} n'existe pas dans {other}.",
            "integer": "Le champ {attribute} doit être un entier.",
            "ip": "Le champ {attribute} doit être une adresse IP valide.",
            "ipv4": "Le champ {attribute} doit être une adresse IPv4 valide.",
            "ipv6": "Le champ {attribute} doit être une adresse IPv6 valide.",
            "json": "Le champ {attribute} doit être un document JSON valide.",
            "lt": {
                "array": "Le tableau {attribute} doit contenir moins de {value} éléments.",
                "file": "La taille du fichier de {attribute} doit être inférieure à {value} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être inférieure à {value}.",
                "string": "Le texte {attribute} doit contenir moins de {value} caractères."
            },
            "lte": {
                "array": "Le tableau {attribute} doit contenir au plus {value} éléments.",
                "file": "La taille du fichier de {attribute} doit être inférieure ou égale à {value} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être inférieure ou égale à {value}.",
                "string": "Le texte {attribute} doit contenir au plus {value} caractères."
            },
            "mac_address": "Le champ {attribute} doit être une adresse MAC valide.",
            "max": {
                "array": "Le tableau {attribute} ne peut contenir plus de {max} éléments.",
                "file": "La taille du fichier de {attribute} ne peut pas dépasser {max} kilo-octets.",
                "numeric": "La valeur de {attribute} ne peut être supérieure à {max}.",
                "string": "Le texte de {attribute} ne peut contenir plus de {max} caractères."
            },
            "mimes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "mimetypes": "Le champ {attribute} doit être un fichier de type : {values}.",
            "min": {
                "array": "Le tableau {attribute} doit contenir au moins {min} éléments.",
                "file": "La taille du fichier de {attribute} doit être supérieure à {min} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être supérieure ou égale à {min}.",
                "string": "Le texte {attribute} doit contenir au moins {min} caractères."
            },
            "multiple_of": "La valeur de {attribute} doit être un multiple de {value}",
            "not_in": "Le champ {attribute} sélectionné n'est pas valide.",
            "not_regex": "Le format du champ {attribute} n'est pas valide.",
            "numeric": "Le champ {attribute} doit contenir un nombre.",
            "password": "Le mot de passe est incorrect",
            "phone": "Le champ {attribute} doit être un numéro valide.",
            "present": "Le champ {attribute} doit être présent.",
            "prohibited": "Le champ {attribute} est interdit.",
            "prohibited_if": "Le champ {attribute} est interdit quand {other} a la valeur {value}.",
            "prohibited_unless": "Le champ {attribute} est interdit à moins que {other} est l'une des valeurs {values}.",
            "prohibits": "Le champ {attribute} interdit {other} d'être présent.",
            "recaptcha": "reCAPTCHA validation failed. Please verify that you are not a robot and try again.",
            "regex": "Le format du champ {attribute} est invalide.",
            "required": "Le champ {attribute} est obligatoire.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "Le champ {attribute} est obligatoire quand la valeur de {other} est {value}.",
            "required_unless": "Le champ {attribute} est obligatoire sauf si {other} est {values}.",
            "required_with": "Le champ {attribute} est obligatoire quand {values} est présent.",
            "required_with_all": "Le champ {attribute} est obligatoire quand {values} sont présents.",
            "required_without": "Le champ {attribute} est obligatoire quand {values} n'est pas présent.",
            "required_without_all": "Le champ {attribute} est requis quand aucun de {values} n'est présent.",
            "same": "Les champs {attribute} et {other} doivent être identiques.",
            "size": {
                "array": "Le tableau {attribute} doit contenir {size} éléments.",
                "file": "La taille du fichier de {attribute} doit être de {size} kilo-octets.",
                "numeric": "La valeur de {attribute} doit être {size}.",
                "string": "Le texte de {attribute} doit contenir {size} caractères."
            },
            "starts_with": "Le champ {attribute} doit commencer avec une des valeurs suivantes : {values}",
            "string": "Le champ {attribute} doit être une chaîne de caractères.",
            "timezone": "Le champ {attribute} doit être un fuseau horaire valide.",
            "unique": "La valeur du champ {attribute} est déjà utilisée.",
            "uploaded": "Le fichier du champ {attribute} n'a pu être téléversé.",
            "url": "Le format de l'URL de {attribute} n'est pas valide.",
            "uuid": "Le champ {attribute} doit être un UUID valide",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "business_listing": {
            "dashboard": {
                "title": "Tableau de bord des annonces d'entreprises",
                "description": "Gérez vos annonces d'entreprises et suivez leur performance",
                "create_listing": "Créer une annonce",
                "stats": {
                    "total_listings": "Annonces totales",
                    "active_listings": "Annonces actives",
                    "total_views": "Vues totales",
                    "inquiries": "Demandes de renseignements",
                    "favorites": "Favoris"
                },
                "table": {
                    "listing": "Annonce",
                    "status": "Statut",
                    "price": "Prix",
                    "creator": "Créateur",
                    "views": "Vues",
                    "inquiries": "Demandes",
                    "favorites": "Favoris",
                    "created": "Créé",
                    "actions": "Actions",
                    "view": "Voir",
                    "analytics": "Analytique",
                    "edit": "Modifier",
                    "delete": "Supprimer",
                    "no_listings_found": "Aucune annonce trouvée",
                    "create_first_listing": "Créer votre première annonce"
                },
                "analytics": "Analytique",
                "track_performance": "Suivez la performance de votre annonce",
                "total_page_views": "Vues totales de la page",
                "messages_received": "Messages reçus",
                "users_interested": "Utilisateurs intéressés",
                "page_views": "Vues de la page",
                "users_who_viewed": "Utilisateurs ayant consulté votre annonce",
                "user": "Utilisateur",
                "date": "Date",
                "message": "Message",
                "status": "Statut",
                "messages_from_buyers": "Messages de clients potentiels",
                "users_who_favorited": "Utilisateurs ayant ajouté votre annonce aux favoris",
                "no_views_yet": "Aucune vue pour le moment",
                "no_inquiries_yet": "Aucune demande pour le moment",
                "no_favorites_yet": "Aucun favori pour le moment",
                "inquiry_details": "Détails de la demande",
                "preferred_contact_time": "Heure de contact souhaitée"
            },
            "index": {
                "title": "Annonces d'entreprises",
                "results_count": "Aucune entreprise trouvées|1 entreprise trouvée|{count} entreprises trouvées",
                "no_businesses_found": "Aucune entreprise trouvée",
                "adjust_search_criteria": "Essayez d'ajuster vos critères de recherche",
                "clear_all_filters": "Effacer tous les filtres",
                "similar_businesses": "Entreprises similaires",
                "favorites": "Mes favoris",
                "no_favorites_yet": "Vous n'avez pas encore ajouté d'annonces à vos favoris.",
                "browse_listings": "Parcourir les annonces",
                "remove_from_favorites": "Retirer des favoris"
            },
            "form": {
                "business_name": "Nom de l'entreprise",
                "description": "Description",
                "industry": "Industrie",
                "asking_price": "Prix demandé ($)",
                "square_footage": "Superficie",
                "year_established": "Année de fondation",
                "business_type": "Type d'entreprise",
                "street_number": "Numéro de rue",
                "street_name": "Nom de rue",
                "city": "Ville",
                "province": "Province",
                "country": "Pays",
                "postal_code": "Code postal",
                "latitude": "Latitude",
                "longitude": "Longitude",
                "publish_listing": "Publier l'annonce",
                "publish_date": "Date de publication",
                "pick_a_date": "Choisir une date",
                "images": "Images",
                "featured_listing": "Annonce en vedette",
                "required": "Requis",
                "enter_business_name": "Entrez le nom de l'entreprise",
                "describe_your_business": "Décrivez votre entreprise...",
                "select_industry": "Sélectionnez l'industrie",
                "enter_asking_price": "Entrez le prix demandé",
                "enter_square_footage": "Entrez la superficie",
                "enter_years_established": "Entrez les années d'existence",
                "select_business_type": "Sélectionnez le type d'entreprise",
                "enter_street_number": "Entrez le numéro de rue",
                "enter_street_name": "Entrez le nom de rue",
                "enter_city": "Entrez la ville",
                "select_province": "Sélectionnez la province",
                "enter_country": "Entrez le pays",
                "enter_postal_code": "Entrez le code postal",
                "enter_latitude": "Entrez la latitude",
                "enter_longitude": "Entrez la longitude",
                "select_status": "Sélectionnez le statut",
                "status": "Statut",
                "location": "Emplacement"
            },
            "business_types": {
                "franchise": "Franchise",
                "independent": "Entreprise indépendante",
                "established": "Entreprise établie"
            },
            "statuses": {
                "draft": "Brouillon",
                "published": "Publié",
                "sold": "Vendu",
                "closed": "Fermé"
            },
            "filters": {
                "search_businesses": "Rechercher des entreprises...",
                "all_industries": "Toutes les industries",
                "all_provinces": "Toutes les provinces",
                "min_price": "Prix min",
                "max_price": "Prix max",
                "city": "Ville",
                "sort_by": "Trier par",
                "newest_first": "Les plus récents en premier",
                "price_low_to_high": "Prix : croissant",
                "price_high_to_low": "Prix : décroissant"
            },
            "image_upload": {
                "drag_and_drop": "Glissez et déposez des images ici",
                "click_to_select": "ou cliquez pour sélectionner des fichiers",
                "file_types": "PNG, JPG, GIF jusqu'à 5 Mo",
                "uploaded_images": "Images téléchargées",
                "set_primary": "Définir comme principale",
                "primary": "Principale",
                "remove": "Supprimer",
                "move_up": "Déplacer vers le haut",
                "move_down": "Déplacer vers le bas",
                "max_images_reached": "Vous avez atteint le maximum de {max} images."
            },
            "show": {
                "businesses": "Entreprises",
                "description": "Description",
                "business_details": "Détails de l'entreprise",
                "years": "ans",
                "sq_ft": "pieds carrés",
                "contact_broker": "Nous contacter",
                "send_message_about": "Envoyer un message à propos de \"{title}\"",
                "message_placeholder": "Je suis intéressé(e) par cette entreprise...",
                "select_best_times": "Sélectionnez les meilleurs moments pour vous joindre",
                "share_via_email": "Partager par courriel",
                "copy_link": "Copier le lien",
                "share_on_facebook": "Partager sur Facebook",
                "share_on_twitter": "Partager sur Twitter",
                "print": "Imprimer",
                "best_time_to_contact": "Meilleur moment pour vous joindre",
                "weekday_am": "Jour de semaine AM",
                "weekday_pm": "Jour de semaine PM",
                "weekend_am": "Fin de semaine AM",
                "weekend_pm": "Fin de semaine PM",
                "send_message": "Envoyer le message",
                "image_gallery": "Galerie d'images",
                "location": "Emplacement"
            },
            "buttons": {
                "back_to_dashboard": "Retour au tableau de bord",
                "cancel": "Annuler",
                "create_listing": "Créer une annonce",
                "save_changes": "Enregistrer les modifications"
            },
            "messages": {
                "link_copied": "Lien copié dans le presse-papiers !",
                "inquiry_sent": "Votre demande de renseignements a été envoyée avec succès."
            },
            "validation": {
                "required_fields": "Veuillez remplir tous les champs obligatoires.",
                "invalid_email": "Veuillez entrer une adresse courriel valide."
            }
        }
    }
};